$(document).ready(() => {
  // ========= Initialize GSAP & Lenis Scroll =========
  const initGsapAndLenis = () => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis();

    lenis.on("scroll", () => {
      ScrollTrigger.update();
      // gsap.ticker.lagSmoothing(10);
    });

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    // gsap.ticker.lagSmoothing(10);

    // Reset scroll position and refresh ScrollTrigger
    $(window).scrollTop(0);
    ScrollTrigger.refresh();
  };

  // ===CUSTOM QUICK ATC====
  const quickATC = () => {
    $(document).on("click", ".quickATCBtn", function () {
      const atcBtn = $(this);
      const variantId = atcBtn.data("variant-id");
      const quantity = Number(atcBtn.data("quantity")) || 1;

      if (!variantId || atcBtn.hasClass("disbaledBtn")) {
        return;
      }

      const loadingIcon = `<span class="button is-loading is-loading--icon-only"></span>`;
      const atcBtnTxt = atcBtn.html();
      atcBtn.empty().html(loadingIcon).addClass("disbaledBtn");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variantId,
          quantity: quantity,
        },
        dataType: "json",
        success: function (response) {
          console.log("Added to cart:", response);
          const finalizeQuickAtc = () => {
            if (typeof Shopify.theme.jsAjaxCart !== "undefined") {
              Shopify.theme.jsAjaxCart.updateView();
              Shopify.theme.jsAjaxCart.showDrawer();
            }
            atcBtn.empty().html(atcBtnTxt).removeClass("disbaledBtn");
          };

          if (
            window.APLThemeHelpers &&
            typeof window.APLThemeHelpers.syncFreeGiftCart === "function"
          ) {
            window.APLThemeHelpers.syncFreeGiftCart({
              showStatus: true,
            }).always(finalizeQuickAtc);
          } else {
            finalizeQuickAtc();
          }
        },
        error: function (xhr) {
          alert("Error adding to cart");
          console.error("Error adding to cart:", xhr.responseText);
          atcBtn.html(atcBtnTxt).removeClass("disbaledBtn");
        },
      });
    });
  };

  // ===COLLECTION TABS====
  const collectionTabs = () => {
    $(document).on("click", ".collectionTabsNavButton", function () {
      const currentTab = $(this);
      const currentSection = currentTab.closest(
        "[data-collection-tabs-section]",
      );
      const currentTabId = currentTab.data("tab-trigger");

      currentSection
        .find(".collectionTabsNavButton")
        .removeClass("is-active")
        .attr("aria-selected", "false");
      currentSection.find(".collectionTabsPanel").removeClass("is-active");

      currentTab.addClass("is-active").attr("aria-selected", "true");
      currentSection
        .find(`[data-tab-panel="${currentTabId}"]`)
        .addClass("is-active");
    });
  };

  // ===CUSTOM COLLECTION SORT====
  const customCollectionSort = () => {
    const buildDropdown = (currentWrap) => {
      const currentSelect = currentWrap.find("#sort-by");
      const currentLabel = currentWrap.find(
        "[data-custom-collection-sort-label]",
      );
      const currentDropdown = currentWrap.find(
        "[data-custom-collection-sort-dropdown]",
      );

      if (!currentSelect.length || !currentDropdown.length) {
        return;
      }

      const selectedOption = currentSelect.find("option:selected");
      currentLabel.text(selectedOption.text());
      currentDropdown.empty();

      currentSelect.find("option").each(function () {
        const currentOption = $(this);
        const optionValue = currentOption.attr("value");
        const optionLabel = currentOption.text();
        const isSelected = currentOption.is(":selected");
        const optionButton = $(`
          <button
            type="button"
            class="customCollectionSortOption${isSelected ? " is-active" : ""}"
            data-custom-collection-sort-option
            data-value="${optionValue}"
            role="option"
            aria-selected="${isSelected ? "true" : "false"}"
          >
            ${optionLabel}
          </button>
        `);

        currentDropdown.append(optionButton);
      });
    };

    $("[data-custom-collection-sort]").each(function () {
      buildDropdown($(this));
    });

    $(document).on(
      "click",
      "[data-custom-collection-sort-trigger]",
      function (event) {
        event.preventDefault();

        const currentWrap = $(this).closest("[data-custom-collection-sort]");
        const isOpen = currentWrap.hasClass("is-open");

        $("[data-custom-collection-sort]").removeClass("is-open");
        $("[data-custom-collection-sort-trigger]").attr(
          "aria-expanded",
          "false",
        );
        $("[data-custom-collection-sort-dropdown]").attr("aria-hidden", "true");

        if (!isOpen) {
          currentWrap.addClass("is-open");
          currentWrap
            .find("[data-custom-collection-sort-trigger]")
            .attr("aria-expanded", "true");
          currentWrap
            .find("[data-custom-collection-sort-dropdown]")
            .attr("aria-hidden", "false");
        }
      },
    );

    $(document).on(
      "click",
      "[data-custom-collection-sort-option]",
      function (event) {
        event.preventDefault();

        const currentOption = $(this);
        const currentWrap = currentOption.closest(
          "[data-custom-collection-sort]",
        );
        const currentSelect = currentWrap.find("#sort-by");
        const nextValue = currentOption.data("value");

        if (!currentSelect.length || !nextValue) {
          return;
        }

        currentSelect.val(nextValue).trigger("change");
        buildDropdown(currentWrap);
        currentWrap.removeClass("is-open");
        currentWrap
          .find("[data-custom-collection-sort-trigger]")
          .attr("aria-expanded", "false");
        currentWrap
          .find("[data-custom-collection-sort-dropdown]")
          .attr("aria-hidden", "true");
      },
    );

    $(document).on(
      "change",
      "[data-custom-collection-sort] #sort-by",
      function () {
        buildDropdown($(this).closest("[data-custom-collection-sort]"));
      },
    );

    $(document).on("click", function (event) {
      if (!$(event.target).closest("[data-custom-collection-sort]").length) {
        $("[data-custom-collection-sort]").removeClass("is-open");
        $("[data-custom-collection-sort-trigger]").attr(
          "aria-expanded",
          "false",
        );
        $("[data-custom-collection-sort-dropdown]").attr("aria-hidden", "true");
      }
    });
  };

  // ===TESTIMONIAL SHOWCASE====
  const testimonialShowcase = () => {
    const pauseSectionVideos = ($section) => {
      $section.find("[data-testimonial-video]").each(function () {
        this.pause();
      });

      $section
        .find("[data-testimonial-video-toggle]")
        .removeClass("is-playing")
        .attr("aria-label", "Play testimonial video");
    };

    $("[data-testimonial-showcase-section]").each(function () {
      const currentSection = $(this);
      const currentCarousel = currentSection.find(
        "[data-testimonial-showcase-carousel]",
      );
      const currentDotsWrap = currentSection.find(
        "[data-testimonial-showcase-dots]",
      );
      const currentSlidesCount =
        Number(currentCarousel.data("testimonial-showcase-count")) || 0;

      if (
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled")
      ) {
        return;
      }

      if (currentSlidesCount > 1 && typeof $.fn.flickity === "function") {
        const isMobile = window.matchMedia("(max-width: 798px)").matches;
        currentCarousel.flickity({
          wrapAround: true,
          prevNextButtons: false,
          pageDots: isMobile,
          adaptiveHeight: false,
          cellAlign: "left",
          contain: true,
          draggable: true,
        });

        if (isMobile && currentDotsWrap.length) {
          const pageDots = currentCarousel.find(".flickity-page-dots");

          if (pageDots.length) {
            currentDotsWrap.empty().append(pageDots);
          }
        }

        currentCarousel.on("change.flickity", function () {
          pauseSectionVideos(currentSection);
        });

        currentCarousel.on("settle.flickity", function () {
          currentCarousel.flickity("resize");
        });
      }
    });

    $(document).on("click", "[data-testimonial-showcase-prev]", function () {
      const currentSection = $(this).closest(
        "[data-testimonial-showcase-section]",
      );
      const currentCarousel = currentSection.find(
        "[data-testimonial-showcase-carousel]",
      );

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-testimonial-showcase-next]", function () {
      const currentSection = $(this).closest(
        "[data-testimonial-showcase-section]",
      );
      const currentCarousel = currentSection.find(
        "[data-testimonial-showcase-carousel]",
      );

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    $(document).on("click", "[data-testimonial-video-toggle]", function () {
      const currentButton = $(this);
      const currentSection = currentButton.closest(
        "[data-testimonial-showcase-section]",
      );
      const currentVideo = currentButton
        .closest("[data-testimonial-video-wrap]")
        .find("[data-testimonial-video]")
        .get(0);

      if (!currentVideo) {
        return;
      }

      if (currentVideo.paused) {
        pauseSectionVideos(currentSection);
        currentVideo.muted = false;
        currentVideo.volume = 1;
        currentVideo.play();
        currentButton
          .addClass("is-playing")
          .attr("aria-label", "Pause testimonial video");
      } else {
        currentVideo.pause();
        currentButton
          .removeClass("is-playing")
          .attr("aria-label", "Play testimonial video");
      }
    });
  };

  // ===MOVEMENT GALLERY====
  const movementGallery = () => {
    $("[data-movement-gallery-section]").each(function () {
      const currentSection = $(this);
      const currentCarousel = currentSection.find(
        "[data-movement-gallery-carousel]",
      );
      const carouselEnabled =
        String(currentSection.data("movement-gallery-carousel-enabled")) ===
        "true";

      if (
        !carouselEnabled ||
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled") ||
        typeof $.fn.flickity !== "function"
      ) {
        return;
      }

      currentCarousel.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        freeScroll: true,
        contain: false,
        groupCells: false,
        cellAlign: "left",
        draggable: true,
        autoPlay: 2600,
        pauseAutoPlayOnHover: false,
        selectedAttraction: 0.018,
        friction: 0.22,
      });

      currentCarousel.on("settle.flickity", function () {
        currentCarousel.flickity("resize");
      });
    });
  };

  // ===CUSTOM PADDLE STEPS====
  const customPaddleSteps = () => {
    const stepsArrowSvg = `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $("[data-custom-paddle-steps-section]").each(function () {
      const currentSection = $(this);
      const currentCarousel = currentSection.find(
        "[data-custom-paddle-steps-carousel]",
      );
      const currentDots = currentSection.find(
        "[data-custom-paddle-steps-dots]",
      );

      if (!currentCarousel.length || typeof $.fn.flickity !== "function") {
        return;
      }

      const setupCarousel = () => {
        const isMobile = window.matchMedia("(max-width: 640px)").matches;

        if (isMobile && !currentCarousel.hasClass("flickity-enabled")) {
          currentSection.addClass("is-mobile-carousel");
          currentCarousel.flickity({
            wrapAround: true,
            prevNextButtons: false,
            pageDots: true,
            contain: false,
            cellAlign: "left",
            draggable: true,
            groupCells: false,
            adaptiveHeight: true,
            imagesLoaded: true,
          });

          const pageDots = currentCarousel.find(".flickity-page-dots");

          if (pageDots.length && currentDots.length) {
            currentDots.empty().append(pageDots);
          }

          currentCarousel.find("img").on("load.customPaddleSteps", function () {
            currentCarousel.flickity("resize");
          });
        } else if (!isMobile && currentCarousel.hasClass("flickity-enabled")) {
          currentSection.removeClass("is-mobile-carousel");
          currentCarousel.find("img").off("load.customPaddleSteps");
          currentCarousel.flickity("destroy");

          if (currentDots.length) {
            currentDots.empty();
          }
        } else if (!isMobile) {
          currentSection.removeClass("is-mobile-carousel");
        }
      };

      setupCarousel();
      $(window)
        .off(`resize.customPaddleSteps-${currentSection.index()}`)
        .on(
          `resize.customPaddleSteps-${currentSection.index()}`,
          setupCarousel,
        );
    });

    $(document).on("click", "[data-custom-paddle-steps-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-custom-paddle-steps-section]")
        .find("[data-custom-paddle-steps-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-custom-paddle-steps-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-custom-paddle-steps-section]")
        .find("[data-custom-paddle-steps-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    $("[data-custom-paddle-steps-prev], [data-custom-paddle-steps-next]").each(
      function () {
        const currentButton = $(this);

        if (!currentButton.find("svg").length) {
          currentButton.html(stepsArrowSvg);
        }
      },
    );
  };

  // ===BULK PRODUCTS GRID====
  const bulkProductsGrid = () => {
    const arrowSvg = `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $("[data-bulk-products-grid-section]").each(function () {
      const currentSection = $(this);
      const currentCarousel = currentSection.find(
        "[data-bulk-products-grid-carousel]",
      );
      const currentDots = currentSection.find("[data-bulk-products-grid-dots]");
      const slideCount = currentCarousel.find(".bulkProductsGridSection__item").length;

      if (!currentCarousel.length || typeof $.fn.flickity !== "function") {
        return;
      }

      const setupCarousel = () => {
        const isMobile = window.matchMedia("(max-width: 798px)").matches;

        if (slideCount <= 1) {
          currentSection.removeClass("is-mobile-carousel is-single-slide");
          currentSection.addClass("is-single-slide");

          if (currentCarousel.hasClass("flickity-enabled")) {
            currentCarousel.find("img").off("load.bulkProductsGrid");
            currentCarousel.flickity("destroy");
          }

          if (currentDots.length) {
            currentDots.empty();
          }

          return;
        }

        if (isMobile && !currentCarousel.hasClass("flickity-enabled")) {
          currentSection.addClass("is-mobile-carousel");
          currentCarousel.flickity({
            wrapAround: true,
            prevNextButtons: false,
            pageDots: true,
            contain: true,
            cellAlign: "left",
            draggable: true,
            groupCells: false,
            adaptiveHeight: true,
            imagesLoaded: true,
          });

          const pageDots = currentCarousel.find(".flickity-page-dots");

          if (pageDots.length && currentDots.length) {
            currentDots.empty().append(pageDots);
          }

          currentCarousel.find("img").on("load.bulkProductsGrid", function () {
            currentCarousel.flickity("resize");
          });
        } else if (!isMobile && currentCarousel.hasClass("flickity-enabled")) {
          currentSection.removeClass("is-mobile-carousel");
          currentCarousel.find("img").off("load.bulkProductsGrid");
          currentCarousel.flickity("destroy");

          if (currentDots.length) {
            currentDots.empty();
          }
        } else if (!isMobile) {
          currentSection.removeClass("is-mobile-carousel is-single-slide");
        }
      };

      setupCarousel();
      $(window)
        .off(`resize.bulkProductsGrid-${currentSection.index()}`)
        .on(`resize.bulkProductsGrid-${currentSection.index()}`, setupCarousel);
    });

    $(document).on("click", "[data-bulk-products-grid-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-bulk-products-grid-section]")
        .find("[data-bulk-products-grid-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-bulk-products-grid-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-bulk-products-grid-section]")
        .find("[data-bulk-products-grid-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    $("[data-bulk-products-grid-prev], [data-bulk-products-grid-next]").each(
      function () {
        const currentButton = $(this);

        if (!currentButton.find("svg").length) {
          currentButton.html(arrowSvg);
        }
      },
    );
  };

  // ===PRODUCT GALLERY CUSTOM UI====
  const productGalleryCustomUI = () => {
    const galleryArrowSvg = `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $(
      ".product-template .product-gallery__main .flickity-prev-next-button",
    ).each(function () {
      const currentButton = $(this);

      if (currentButton.find("svg").length) {
        currentButton.html(galleryArrowSvg);
      }
    });
  };

  // ===CUSTOM PADDLE CANVAS====
  const customPaddleCanvas = () => {
    const customStages = $("[data-custom-paddle-stage]");

    if (!customStages.length) {
      return;
    }

    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const DEFAULT_EDITOR_BG_COLOR = "#d7d7d7";
    const DEFAULT_EDITOR_CROP_WIDTH = 430;
    const DEFAULT_EDITOR_CROP_HEIGHT = 714;
    const DEFAULT_EDITOR_CROP_HEIGHT_RATIO =
      DEFAULT_EDITOR_CROP_HEIGHT / DEFAULT_EDITOR_CROP_WIDTH;
    const frontImage = new Image();
    const backImage = new Image();
    const frontFilledMaskImage = new Image();
    const backFilledMaskImage = new Image();
    const coverRegionsMaskImage = new Image();
    const topLineMaskImage = new Image();
    const bottomLineMaskImage = new Image();
    const defaultUploadMeta = "PNG, JPG, SVG up to 20MB. Best size: 1080 x 1920 px.";
    const baseStage = customStages.first();
    const baseImageElement = baseStage.find(".aplCustomPaddleGalleryBaseImage").get(0);
    const currentTemplate = String(baseStage.data("custom-paddle-template") || "");
    const isPaddleProTemplate =
      currentTemplate === "paddle-pro";
    const isCoverTemplate = currentTemplate === "cover";
    const imageState = {
      front: null,
      back: null,
      topText: "",
      bottomText: "",
      transforms: {
        front: {
          scale: 1,
          rotation: 0,
          bgColor: "transparent",
          objectUrl: "",
          crop: null,
        },
        back: {
          scale: 1,
          rotation: 0,
          bgColor: "transparent",
          objectUrl: "",
          crop: null,
        },
      },
    };
    const textMaskBounds = {
      top: null,
      bottom: null,
    };
    const filledMaskBounds = {
      front: null,
      back: null,
    };
    const coverRegionBounds = {
      front: null,
      back: null,
    };
    const editorMaskDataUrls = {
      front: "",
      back: "",
    };
    const paddleRegions = {
      front: {
        x: 0.084,
        y: 0.055,
        width: 0.315,
        height: 0.54,
      },
      back: {
        x: 0.6,
        y: 0.055,
        width: 0.315,
        height: 0.54,
      },
    };
    const textDebugSettings = {
      top: {
        front: {
          offsetX: -50,
          offsetY: -59,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 46,
        },
        back: {
          offsetX: -169,
          offsetY: -59,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 46,
        },
      },
      bottom: {
        front: {
          offsetX: -53,
          offsetY: -77,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 24,
        },
        back: {
          offsetX: -172,
          offsetY: -77,
          widthAdjust: 0,
          heightAdjust: 0,
          fontSize: 24,
        },
      },
    };
    const editorState = {
      side: "front",
      interaction: "",
      lastPointerX: 0,
      lastPointerY: 0,
    };
    const paddleMediaDebugSettings = {
      front: {
        x: -20,
        y: -14,
        width: -79,
        height: -127,
      },
      back: {
        x: -136,
        y: -10,
        width: -76,
        height: -127,
      },
    };
    const coverMediaDebugSettings = {
      front: {
        x: -18,
        y: -56,
        width: -80,
        height: -120,
      },
      back: {
        x: -133,
        y: -56,
        width: -82,
        height: -120,
      },
    };
    const activeMediaDebugSettings = isCoverTemplate
      ? coverMediaDebugSettings
      : paddleMediaDebugSettings;
    const EDITOR_STAGE_SIZE = 720;
    const editorDebugSettings = {
      frameX: 145,
      frameY: 3,
      frameWidth: DEFAULT_EDITOR_CROP_WIDTH,
      frameHeight: DEFAULT_EDITOR_CROP_HEIGHT,
    };

    const getEditorCropHeightRatio = (side) => {
      const adjustedMaskBounds = side ? getAdjustedRenderBounds(side) : null;

      if (adjustedMaskBounds && adjustedMaskBounds.width) {
        return adjustedMaskBounds.height / adjustedMaskBounds.width;
      }

      return DEFAULT_EDITOR_CROP_HEIGHT_RATIO;
    };

    const getEditorFrameRect = (side) => {
      const ratio = getEditorCropHeightRatio(side);

      return {
        x: editorDebugSettings.frameX,
        y: Math.round((EDITOR_STAGE_SIZE - editorDebugSettings.frameWidth * ratio) / 2),
        width: editorDebugSettings.frameWidth,
        height: editorDebugSettings.frameWidth * ratio,
      };
    };

    const getDefaultCropRect = (side) => {
      const ratio = getEditorCropHeightRatio(side);
      const cropHeight = DEFAULT_EDITOR_CROP_WIDTH * ratio;

      return {
        x: Math.round((EDITOR_STAGE_SIZE - DEFAULT_EDITOR_CROP_WIDTH) / 2),
        y: Math.round((EDITOR_STAGE_SIZE - cropHeight) / 2),
        width: DEFAULT_EDITOR_CROP_WIDTH,
        height: cropHeight,
      };
    };

    const ensureCropRect = (side) => {
      if (!imageState.transforms[side].crop) {
        imageState.transforms[side].crop = getDefaultCropRect(side);
      }

      return imageState.transforms[side].crop;
    };

    const syncBackgroundProperties = () => {
      ["front", "back"].forEach((side) => {
        const propertyValue =
          imageState.transforms[side].bgColor === "transparent"
            ? ""
            : imageState.transforms[side].bgColor;
        $(`[data-custom-paddle-bg-property="${side}"]`).val(
          propertyValue,
        );
      });
    };

    const getResolvedFillColor = (side) => {
      const color = String(imageState.transforms[side].bgColor || "transparent");
      return color === "transparent" ? "" : color;
    };

    const getRotatedDimensions = (image, rotation) => {
      const normalizedRotation = Math.abs(rotation % 180);

      if (normalizedRotation === 90) {
        return {
          width: image.height,
          height: image.width,
        };
      }

      return {
        width: image.width,
        height: image.height,
      };
    };

    const getCanvasRegion = (canvas, side) => {
      const region = paddleRegions[side];

      return {
        x: canvas.width * region.x,
        y: canvas.height * region.y,
        width: canvas.width * region.width,
        height: canvas.height * region.height,
      };
    };

    const getAdjustedMaskBounds = (side) => {
      const baseBounds = filledMaskBounds[side];
      const debugSettings = activeMediaDebugSettings[side];

      if (!baseBounds) {
        return null;
      }

      return {
        x: baseBounds.x + debugSettings.x,
        y: baseBounds.y + debugSettings.y,
        width: Math.max(20, baseBounds.width + debugSettings.width),
        height: Math.max(20, baseBounds.height + debugSettings.height),
      };
    };

    const getAdjustedCoverBounds = (side) => {
      const baseBounds = coverRegionBounds[side];
      const debugSettings = activeMediaDebugSettings[side];

      if (!baseBounds) {
        return null;
      }

      return {
        x: baseBounds.x + debugSettings.x,
        y: baseBounds.y + debugSettings.y,
        width: Math.max(20, baseBounds.width + debugSettings.width),
        height: Math.max(20, baseBounds.height + debugSettings.height),
      };
    };

    const getAdjustedRenderBounds = (side) => {
      if (isPaddleProTemplate) {
        return getAdjustedMaskBounds(side);
      }

      if (isCoverTemplate) {
        return getAdjustedCoverBounds(side);
      }

      return null;
    };

    const getMaskBounds = (maskAsset) => {
      if (!(maskAsset.complete && maskAsset.naturalWidth)) {
        return null;
      }

      const offCanvas = document.createElement("canvas");
      offCanvas.width = maskAsset.naturalWidth;
      offCanvas.height = maskAsset.naturalHeight;
      const offCtx = offCanvas.getContext("2d");
      offCtx.clearRect(0, 0, offCanvas.width, offCanvas.height);
      offCtx.drawImage(maskAsset, 0, 0, offCanvas.width, offCanvas.height);
      const { data } = offCtx.getImageData(0, 0, offCanvas.width, offCanvas.height);
      let minX = offCanvas.width;
      let minY = offCanvas.height;
      let maxX = 0;
      let maxY = 0;
      let hasPixel = false;

      for (let y = 0; y < offCanvas.height; y += 1) {
        for (let x = 0; x < offCanvas.width; x += 1) {
          const alpha = data[y * offCanvas.width * 4 + x * 4 + 3];

          if (alpha > 20) {
            hasPixel = true;
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }

      if (!hasPixel) {
        return null;
      }

      return {
        x: minX,
        y: minY,
        width: maxX - minX + 1,
        height: maxY - minY + 1,
      };
    };

    const buildEditorMaskDataUrl = (maskAsset, maskBounds) => {
      if (!(maskAsset && maskBounds && maskAsset.complete && maskAsset.naturalWidth)) {
        return "";
      }

      const maskCanvas = document.createElement("canvas");
      maskCanvas.width = Math.max(1, Math.round(maskBounds.width));
      maskCanvas.height = Math.max(1, Math.round(maskBounds.height));

      const maskCtx = maskCanvas.getContext("2d");
      maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
      maskCtx.drawImage(
        maskAsset,
        maskBounds.x,
        maskBounds.y,
        maskBounds.width,
        maskBounds.height,
        0,
        0,
        maskCanvas.width,
        maskCanvas.height,
      );

      const outlineCanvas = document.createElement("canvas");
      outlineCanvas.width = maskCanvas.width;
      outlineCanvas.height = maskCanvas.height;
      const outlineCtx = outlineCanvas.getContext("2d");
      const outlineInset = Math.max(
        2,
        Math.round(Math.min(maskCanvas.width, maskCanvas.height) * 0.012),
      );

      outlineCtx.clearRect(0, 0, outlineCanvas.width, outlineCanvas.height);
      outlineCtx.fillStyle = "#2794ff";
      outlineCtx.fillRect(0, 0, outlineCanvas.width, outlineCanvas.height);
      outlineCtx.globalCompositeOperation = "destination-in";
      outlineCtx.drawImage(maskCanvas, 0, 0);
      outlineCtx.globalCompositeOperation = "destination-out";
      outlineCtx.drawImage(
        maskCanvas,
        0,
        0,
        maskCanvas.width,
        maskCanvas.height,
        outlineInset,
        outlineInset,
        Math.max(1, maskCanvas.width - outlineInset * 2),
        Math.max(1, maskCanvas.height - outlineInset * 2),
      );
      outlineCtx.globalCompositeOperation = "source-over";

      return outlineCanvas.toDataURL("image/png");
    };

    const drawSourceImageCentered = (
      ctx,
      sourceImage,
      rect,
      scaleMultiplier,
      rotation,
    ) => {
      if (!sourceImage || !rect) {
        return;
      }

      const rotatedDimensions = getRotatedDimensions(sourceImage, rotation || 0);
      const baseScale = Math.min(
        rect.width / rotatedDimensions.width,
        rect.height / rotatedDimensions.height,
      );
      const resolvedScale = Math.max(0.12, baseScale * (scaleMultiplier || 1));
      const centerX = rect.x + rect.width / 2;
      const centerY = rect.y + rect.height / 2;

      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(((rotation || 0) * Math.PI) / 180);
      ctx.scale(resolvedScale, resolvedScale);
      ctx.drawImage(
        sourceImage,
        -sourceImage.width / 2,
        -sourceImage.height / 2,
        sourceImage.width,
        sourceImage.height,
      );
      ctx.restore();
    };

    const buildCropArtworkCanvas = (side) => {
      const transformState = imageState.transforms[side];
      const cropRect = ensureCropRect(side);
      const sourceImage = imageState[side];
      const stageCanvas = document.createElement("canvas");
      stageCanvas.width = EDITOR_STAGE_SIZE;
      stageCanvas.height = EDITOR_STAGE_SIZE;
      const stageCtx = stageCanvas.getContext("2d");
      const frameRect = getEditorFrameRect(side);
      const fillColor = getResolvedFillColor(side);

      stageCtx.clearRect(0, 0, stageCanvas.width, stageCanvas.height);
      if (fillColor) {
        stageCtx.fillStyle = fillColor;
        stageCtx.fillRect(0, 0, stageCanvas.width, stageCanvas.height);
      }
      drawSourceImageCentered(
        stageCtx,
        sourceImage,
        frameRect,
        transformState.scale,
        transformState.rotation,
      );

      const cropCanvas = document.createElement("canvas");
      cropCanvas.width = Math.max(10, Math.round(cropRect.width));
      cropCanvas.height = Math.max(10, Math.round(cropRect.height));
      const cropCtx = cropCanvas.getContext("2d");

      if (fillColor) {
        cropCtx.fillStyle = fillColor;
        cropCtx.fillRect(0, 0, cropCanvas.width, cropCanvas.height);
      }

      cropCtx.drawImage(
        stageCanvas,
        cropRect.x,
        cropRect.y,
        cropRect.width,
        cropRect.height,
        0,
        0,
        cropCanvas.width,
        cropCanvas.height,
      );

      return cropCanvas;
    };

    const drawImageInRect = (ctx, sourceImage, rect, transformState) => {
      if (!rect) {
        return;
      }

      ctx.save();
      const fallbackFill = getResolvedFillColor(
        transformState === imageState.transforms.back ? "back" : "front",
      );

      if (fallbackFill) {
        ctx.fillStyle = fallbackFill;
        ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
      }

      if (!sourceImage) {
        ctx.restore();
        return;
      }

      ctx.beginPath();
      ctx.rect(rect.x, rect.y, rect.width, rect.height);
      ctx.clip();

      const rotatedDimensions = getRotatedDimensions(
        sourceImage,
        transformState.rotation || 0,
      );
      const baseScale = Math.max(
        rect.width / rotatedDimensions.width,
        rect.height / rotatedDimensions.height,
      );
      const resolvedScale = Math.max(0.12, baseScale * (transformState.scale || 1));
      const centerX = rect.x + rect.width / 2 + (transformState.offsetX || 0);
      const centerY = rect.y + rect.height / 2 + (transformState.offsetY || 0);

      ctx.translate(centerX, centerY);
      ctx.rotate(((transformState.rotation || 0) * Math.PI) / 180);
      ctx.scale(resolvedScale, resolvedScale);
      ctx.drawImage(
        sourceImage,
        -sourceImage.width / 2,
        -sourceImage.height / 2,
        sourceImage.width,
        sourceImage.height,
      );
      ctx.restore();
    };

    const getMaskRegions = (maskAsset) => {
      if (!(maskAsset.complete && maskAsset.naturalWidth)) {
        return null;
      }

      const offCanvas = document.createElement("canvas");
      const width = maskAsset.naturalWidth;
      const height = maskAsset.naturalHeight;
      const midpoint = Math.floor(width / 2);
      const result = {
        left: null,
        right: null,
      };

      offCanvas.width = width;
      offCanvas.height = height;

      const offCtx = offCanvas.getContext("2d");
      offCtx.clearRect(0, 0, width, height);
      offCtx.drawImage(maskAsset, 0, 0, width, height);

      const { data } = offCtx.getImageData(0, 0, width, height);

      const scanSide = (xStart, xEnd) => {
        let minX = width;
        let minY = height;
        let maxX = 0;
        let maxY = 0;
        let hasPixel = false;

        for (let y = 0; y < height; y += 1) {
          for (let x = xStart; x < xEnd; x += 1) {
            const alphaIndex = y * width * 4 + x * 4 + 3;

            const red = data[alphaIndex - 3];
            const green = data[alphaIndex - 2];
            const blue = data[alphaIndex - 1];
            const brightness = (red + green + blue) / 3;

            if (data[alphaIndex] > 20 && brightness > 150) {
              hasPixel = true;
              minX = Math.min(minX, x);
              minY = Math.min(minY, y);
              maxX = Math.max(maxX, x);
              maxY = Math.max(maxY, y);
            }
          }
        }

        if (!hasPixel) {
          return null;
        }

        return {
          x: minX,
          y: minY,
          width: maxX - minX + 1,
          height: maxY - minY + 1,
        };
      };

      result.left = scanSide(0, midpoint);
      result.right = scanSide(midpoint, width);

      return result;
    };

    const fitFontSize = (
      ctx,
      textValue,
      maxWidth,
      maxHeight,
      fontFamily,
      weight,
      startingSize,
    ) => {
      let fontSize = startingSize;

      while (fontSize > 10) {
        ctx.font = `${weight} ${fontSize}px ${fontFamily}`;
        const metrics = ctx.measureText(textValue);
        const textHeight =
          (metrics.actualBoundingBoxAscent || fontSize * 0.8) +
          (metrics.actualBoundingBoxDescent || fontSize * 0.2);

        if (metrics.width <= maxWidth && textHeight <= maxHeight) {
          return fontSize;
        }

        fontSize -= 1;
      }

      return 10;
    };

    const getAdjustedRegion = (region, settings) => {
      if (!region) {
        return null;
      }

      return {
        x: region.x + settings.offsetX,
        y: region.y + settings.offsetY,
        width: Math.max(20, region.width + settings.widthAdjust),
        height: Math.max(12, region.height + settings.heightAdjust),
      };
    };

    const drawPaddleComposite = (ctx, options = {}) => {
      const frontArtwork = imageState.front ? buildCropArtworkCanvas("front") : null;
      const backArtwork = imageState.back ? buildCropArtworkCanvas("back") : null;
      const showTransparencyGuide = options.showTransparencyGuide === true;

      const drawMaskedArtwork = (artworkCanvas, side, maskImage, maskBounds) => {
        if (!(artworkCanvas && maskImage && maskBounds)) {
          drawImageInRect(
            ctx,
            artworkCanvas,
            getCanvasRegion(ctx.canvas, side),
            imageState.transforms[side],
          );
          return;
        }

        const layerCanvas = document.createElement("canvas");
        layerCanvas.width = ctx.canvas.width;
        layerCanvas.height = ctx.canvas.height;
        const layerCtx = layerCanvas.getContext("2d");
        const fillColor = getResolvedFillColor(side);

        if (!fillColor && showTransparencyGuide) {
          layerCtx.fillStyle = "#e7e7e7";
          layerCtx.fillRect(
            maskBounds.x,
            maskBounds.y,
            maskBounds.width,
            maskBounds.height,
          );
        }

        layerCtx.drawImage(
          artworkCanvas,
          maskBounds.x,
          maskBounds.y,
          maskBounds.width,
          maskBounds.height,
        );

        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskImage, 0, 0, layerCanvas.width, layerCanvas.height);
        layerCtx.globalCompositeOperation = "source-over";
        ctx.drawImage(layerCanvas, 0, 0);
      };

      drawMaskedArtwork(
        frontArtwork,
        "front",
        frontFilledMaskImage.complete && frontFilledMaskImage.naturalWidth
          ? frontFilledMaskImage
          : null,
        getAdjustedMaskBounds("front"),
      );
      drawMaskedArtwork(
        backArtwork,
        "back",
        backFilledMaskImage.complete && backFilledMaskImage.naturalWidth
          ? backFilledMaskImage
          : null,
        getAdjustedMaskBounds("back"),
      );

      if (baseImageElement && baseImageElement.complete && baseImageElement.naturalWidth) {
        ctx.drawImage(baseImageElement, 0, 0, ctx.canvas.width, ctx.canvas.height);
      }
    };

    const drawCoverComposite = (ctx, options = {}) => {
      const frontArtwork = imageState.front ? buildCropArtworkCanvas("front") : null;
      const backArtwork = imageState.back ? buildCropArtworkCanvas("back") : null;
      const showTransparencyGuide = options.showTransparencyGuide === true;

      const drawCoverArtwork = (artworkCanvas, side) => {
        const bounds = getAdjustedCoverBounds(side);

        if (!bounds) {
          return;
        }

        if (!artworkCanvas) {
          if (showTransparencyGuide) {
            ctx.save();
            ctx.fillStyle = "#e7e7e7";
            ctx.fillRect(bounds.x, bounds.y, bounds.width, bounds.height);
            ctx.restore();
          }
          return;
        }

        ctx.save();
        ctx.drawImage(
          artworkCanvas,
          bounds.x,
          bounds.y,
          bounds.width,
          bounds.height,
        );
        ctx.restore();
      };

      drawCoverArtwork(frontArtwork, "front");
      drawCoverArtwork(backArtwork, "back");

      if (baseImageElement && baseImageElement.complete && baseImageElement.naturalWidth) {
        ctx.drawImage(baseImageElement, 0, 0, ctx.canvas.width, ctx.canvas.height);
      }
    };

    const redrawAll = () => {
      $("[data-custom-paddle-stage]").each(function () {
        const stage = $(this);
        const canvas = stage.find("[data-custom-paddle-stage-canvas]").get(0);
        const mode = String(stage.data("custom-paddle-mode") || "image");

        if (!canvas) {
          return;
        }

        const ctx = canvas.getContext("2d");
        const width = canvas.width;
        const height = canvas.height;

        ctx.clearRect(0, 0, width, height);

        if (mode === "text") {
          const drawMaskedTextLayer = (
            textValue,
            fillStyle,
            maskAsset,
            boundsKey,
            fontFamily,
            fontWeight,
            startingSize,
          ) => {
            const maskBounds = textMaskBounds[boundsKey];

            if (
              !textValue ||
              !(maskAsset.complete && maskAsset.naturalWidth) ||
              !maskBounds
            ) {
              return;
            }

            const tempCanvas = document.createElement("canvas");
            tempCanvas.width = width;
            tempCanvas.height = height;
            const tempCtx = tempCanvas.getContext("2d");
            const drawTextInRegion = (region, sideKey) => {
              const currentSettings = textDebugSettings[boundsKey][sideKey];
              const adjustedRegion = getAdjustedRegion(region, currentSettings);

              if (!adjustedRegion) {
                return;
              }

              const textToRender = String(textValue).trim();

              if (!textToRender) {
                return;
              }

              if (!region) {
                return;
              }

              const paddingX = 12;
              const paddingY = 4;
              const fontSize = fitFontSize(
                tempCtx,
                textToRender,
                Math.max(adjustedRegion.width - paddingX * 2, 40),
                Math.max(adjustedRegion.height - paddingY * 2, 12),
                fontFamily,
                fontWeight,
                currentSettings.fontSize || startingSize,
              );

              tempCtx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
              tempCtx.fillText(
                textToRender,
                adjustedRegion.x + adjustedRegion.width / 2,
                adjustedRegion.y + adjustedRegion.height / 2,
              );
            };

            tempCtx.clearRect(0, 0, width, height);
            tempCtx.fillStyle = fillStyle;
            tempCtx.textAlign = "center";
            tempCtx.textBaseline = "middle";
            drawTextInRegion(maskBounds.left, "front");
            drawTextInRegion(maskBounds.right, "back");
            ctx.drawImage(tempCanvas, 0, 0);
          };

          drawMaskedTextLayer(
            imageState.topText,
            "#111111",
            topLineMaskImage,
            "top",
            '"Times New Roman"',
            "700",
            46,
          );

          drawMaskedTextLayer(
            imageState.bottomText,
            "#111111",
            bottomLineMaskImage,
            "bottom",
            '"Helvetica Neue", Arial, sans-serif',
            "600",
            24,
          );
        } else if (isPaddleProTemplate) {
          drawPaddleComposite(ctx, { showTransparencyGuide: true });
        } else if (isCoverTemplate) {
          drawCoverComposite(ctx, { showTransparencyGuide: true });
        }
      });

      syncMediaDebugPanel();
    };

    const handleUpload = (file, side) => {
      return new Promise((resolve, reject) => {
        if (!file || !side) {
          reject(new Error("Missing upload file or target side."));
          return;
        }

        const reader = new FileReader();
        const targetImage = side === "front" ? frontImage : backImage;

        reader.onload = function (event) {
          targetImage.onload = function () {
            imageState[side] = targetImage;
            imageState.transforms[side].scale = 1;
            imageState.transforms[side].rotation = 0;
            imageState.transforms[side].objectUrl = String(
              event.target.result || "",
            );
            imageState.transforms[side].crop = getDefaultCropRect(side);
            redrawAll();
            resolve();
          };

          targetImage.onerror = function () {
            reject(new Error("Unable to load selected image."));
          };

          targetImage.src = event.target.result;
        };

        reader.onerror = function () {
          reject(new Error("Unable to read selected image."));
        };

        reader.readAsDataURL(file);
      });
    };

    const showUploadToast = (message, type = "error") => {
      let toast = $(".aplCustomPaddleToast");

      if (!toast.length) {
        toast = $(
          '<div class="aplCustomPaddleToast" aria-live="polite"></div>',
        );
        $("body").append(toast);
      }

      toast.removeClass("is-visible is-error is-success");
      toast.text(message).addClass(`is-${type}`);

      window.clearTimeout(window.aplCustomPaddleToastTimer);

      requestAnimationFrame(() => {
        toast.addClass("is-visible");
      });

      window.aplCustomPaddleToastTimer = window.setTimeout(() => {
        toast.removeClass("is-visible");
      }, 3200);
    };

    const showCartProgressToast = () => {
      showUploadToast("Adding to cart...", "success");
    };

    const clearCustomPaddleSide = (side) => {
      imageState[side] = null;
      imageState.transforms[side].scale = 1;
      imageState.transforms[side].rotation = 0;
      imageState.transforms[side].bgColor = "transparent";
      imageState.transforms[side].objectUrl = "";
      imageState.transforms[side].crop = getDefaultCropRect(side);

      $(`[data-custom-paddle-upload="${side}"]`).val("");
      $(`[data-custom-paddle-upload-meta="${side}"]`).text(defaultUploadMeta);
      $(`[data-custom-paddle-upload-preview="${side}"]`).empty();
      $(`[data-custom-paddle-upload="${side}"]`)
        .closest(".aplCustomPaddleUploadField")
        .removeClass("has-file");
      $(`[data-custom-paddle-adjust-trigger="${side}"]`).prop("disabled", true);
      $(`[data-custom-paddle-remove-trigger="${side}"]`).prop("disabled", true);
      syncBackgroundProperties();
      redrawAll();
    };

    const buildCompositePreviewCanvas = (currentStage) => {
      if (!currentStage || !currentStage.length) {
        return null;
      }

      const currentTemplate = String(
        currentStage.data("custom-paddle-template") || "",
      );
      const stageCanvas = currentStage
        .find("[data-custom-paddle-stage-canvas]")
        .get(0);

      if (!stageCanvas) {
        return null;
      }

      const previewCanvas = document.createElement("canvas");
      previewCanvas.width = stageCanvas.width;
      previewCanvas.height = stageCanvas.height;

      const previewCtx = previewCanvas.getContext("2d");

      if (currentTemplate === "paddle-pro") {
        drawPaddleComposite(previewCtx, { showTransparencyGuide: false });
      } else if (currentTemplate === "cover") {
        drawCoverComposite(previewCtx, { showTransparencyGuide: false });
      } else {
        previewCtx.drawImage(
          stageCanvas,
          0,
          0,
          previewCanvas.width,
          previewCanvas.height,
        );
      }

      return previewCanvas;
    };

    const canvasToFile = (canvas, fileName) =>
      new Promise((resolve, reject) => {
        if (!canvas) {
          reject(new Error("Missing preview canvas."));
          return;
        }

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Unable to generate preview image."));
              return;
            }

            resolve(
              new File([blob], fileName, {
                type: "image/png",
              }),
            );
          },
          "image/png",
          1,
        );
      });

    const assignFileToInput = (input, file) => {
      if (!input || !file) {
        return;
      }

      const fileList = new DataTransfer();
      fileList.items.add(file);
      input.files = fileList.files;
    };

    const syncCustomPaddleFileNameProperty = (form, side, fileName) => {
      if (!form || !side) {
        return;
      }

      const propertyInput = form.querySelector(
        `[data-custom-paddle-file-name-property="${side}"]`,
      );

      if (propertyInput) {
        propertyInput.value = fileName || "";
      }
    };

    const validateUploadFile = (file) => {
      return new Promise((resolve, reject) => {
        if (file.size > MAX_FILE_SIZE) {
          reject("Please upload an image below 20MB.");
          return;
        }

        resolve();
      });
    };

    $(document).on("change", "[data-custom-paddle-upload]", function () {
      const input = $(this);
      const side = input.data("custom-paddle-upload");
      const file = this.files && this.files[0] ? this.files[0] : null;
      const meta = $(`[data-custom-paddle-upload-meta="${side}"]`);
      const field = input.closest(".aplCustomPaddleUploadField");
      const preview = $(`[data-custom-paddle-upload-preview="${side}"]`);

      if (!file) {
        return;
      }

      syncCustomPaddleFileNameProperty(this.form, side, file.name);

      validateUploadFile(file)
        .then(() => {
          meta.text(file.name);
          field.addClass("has-file");
          preview
            .empty()
            .append(
              `<img src="${URL.createObjectURL(file)}" alt="${side} upload preview">`,
            );
          handleUpload(file, side)
            .then(() => {
              field
                .closest(".aplCustomPaddleUploadItem")
                .find(`[data-custom-paddle-adjust-trigger="${side}"]`)
                .prop("disabled", false);
              field
                .closest(".aplCustomPaddleUploadItem")
                .find(`[data-custom-paddle-remove-trigger="${side}"]`)
                .prop("disabled", false);
              openAdjustor(side);
              showUploadToast(
                `${side === "front" ? "Front" : "Back"} image uploaded.`,
                "success",
              );
            })
            .catch((uploadError) => {
              input.val("");
              field.removeClass("has-file");
              preview.empty();
              meta.text(defaultUploadMeta);
              field
                .closest(".aplCustomPaddleUploadItem")
                .find(
                  `[data-custom-paddle-adjust-trigger="${side}"], [data-custom-paddle-remove-trigger="${side}"]`,
                )
                .prop("disabled", true);
              showUploadToast(
                uploadError && uploadError.message
                  ? uploadError.message
                  : "Unable to load selected image.",
                "error",
              );
            });
        })
        .catch((errorMessage) => {
          input.val("");
          syncCustomPaddleFileNameProperty(this.form, side, "");
          field.removeClass("has-file");
          preview.empty();
          meta.text(defaultUploadMeta);
          field
            .closest(".aplCustomPaddleUploadItem")
            .find(
              `[data-custom-paddle-adjust-trigger="${side}"], [data-custom-paddle-remove-trigger="${side}"]`,
            )
            .prop("disabled", true);
          showUploadToast(errorMessage, "error");
        });
    });

    $(document).on("input", "[data-custom-paddle-text-input]", function () {
      const input = $(this);
      const target = input.data("custom-paddle-text-input");

      if (target === "top") {
        imageState.topText = input.val();
      }

      if (target === "bottom") {
        imageState.bottomText = input.val();
      }

      redrawAll();
    });

    $(document).on(
      "click",
      "[data-custom-paddle-preview-trigger]",
      function () {
        const currentForm = $(this).closest("[data-product-form]");
        const currentGallery = currentForm
          .closest(".product_section")
          .find(".product-gallery__main");
        const currentStage = currentGallery
          .find("[data-custom-paddle-stage]")
          .first();
        const stageCanvas = currentStage
          .find("[data-custom-paddle-stage-canvas]")
          .get(0);
        const currentGalleryEl = currentGallery.get(0);
        const currentFlickity = currentGalleryEl
          ? window.Flickity.data(currentGalleryEl)
          : null;

        if (!currentStage.length || !stageCanvas) {
          return;
        }

        if (currentFlickity) {
          currentFlickity.select(0, false, true);
          currentFlickity.resize();
          currentGallery
            .find(".product-gallery__thumbnail")
            .removeClass("is-nav-selected")
            .eq(0)
            .addClass("is-nav-selected");
        }

        const previewCanvas = buildCompositePreviewCanvas(currentStage);

        if (!previewCanvas) {
          return;
        }

        const previewMarkup = `
        <div class="aplCustomPaddlePreviewPopup">
          <img src="${previewCanvas.toDataURL("image/png")}" alt="Custom paddle preview">
        </div>
      `;

        if ($.fancybox) {
          $.fancybox.open({
            src: previewMarkup,
            type: "html",
            touch: false,
            smallBtn: true,
          });
        }
      },
    );

    const drawEditorViewport = ($content, side) => {
      const previewCanvas = $content.find("[data-custom-paddle-editor-preview]").get(0);
      const transformState = imageState.transforms[side];
      const sourceImage = imageState[side];
      const frameRect = getEditorFrameRect(side);
      const cropRect = ensureCropRect(side);
      const stage = $content.find("[data-custom-paddle-crop-stage]");
      const imageLayer = $content.find("[data-custom-paddle-crop-image]");
      const cropBox = $content.find("[data-custom-paddle-crop-box]");
      const cropShape = $content.find("[data-custom-paddle-crop-shape]");
      const colorSwatch = $content.find("[data-editor-color-swatch]");
      const currentMaskDataUrl = editorMaskDataUrls[side] || "";
      const fillColor = getResolvedFillColor(side);

      stage.css({
        width: "100%",
        height: "100%",
        backgroundColor: fillColor || DEFAULT_EDITOR_BG_COLOR,
      });

      colorSwatch.css("backgroundColor", fillColor || DEFAULT_EDITOR_BG_COLOR);

      imageLayer.css({
        left: `${(frameRect.x / EDITOR_STAGE_SIZE) * 100}%`,
        top: `${(frameRect.y / EDITOR_STAGE_SIZE) * 100}%`,
        width: `${(frameRect.width / EDITOR_STAGE_SIZE) * 100}%`,
        height: `${(frameRect.height / EDITOR_STAGE_SIZE) * 100}%`,
      });

      if (sourceImage && transformState.objectUrl) {
        imageLayer.attr("src", transformState.objectUrl);
        imageLayer.css({
          transform: `rotate(${transformState.rotation || 0}deg) scale(${transformState.scale || 1})`,
        });
      }

      cropBox.css({
        left: `${(cropRect.x / EDITOR_STAGE_SIZE) * 100}%`,
        top: `${(cropRect.y / EDITOR_STAGE_SIZE) * 100}%`,
        width: `${(cropRect.width / EDITOR_STAGE_SIZE) * 100}%`,
        height: `${(cropRect.height / EDITOR_STAGE_SIZE) * 100}%`,
      });

      cropBox.toggleClass("has-paddle-shape", Boolean(currentMaskDataUrl));
      cropShape.css(
        "--apl-custom-paddle-crop-outline",
        currentMaskDataUrl ? `url("${currentMaskDataUrl}")` : "none",
      );

      stage.addClass("has-solid-bg");

      if (previewCanvas) {
        const previewCtx = previewCanvas.getContext("2d");
        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
        if (isPaddleProTemplate) {
          drawPaddleComposite(previewCtx, { showTransparencyGuide: true });
        } else if (isCoverTemplate) {
          drawCoverComposite(previewCtx, { showTransparencyGuide: true });
        }
      }
    };

    const openAdjustor = (side) => {
      if (!imageState[side]) {
        showUploadToast(
          `Upload the ${side === "front" ? "front" : "back"} image first.`,
          "error",
        );
        return;
      }

      editorState.side = side;

      const adjustorMarkup = `
        <div class="aplCustomPaddleEditorModal" data-custom-paddle-editor-modal>
          <div class="aplCustomPaddleEditorShell">
            <div class="aplCustomPaddleEditorPreviewColumn">
              <canvas class="aplCustomPaddleEditorPreviewCanvas" data-custom-paddle-editor-preview width="764" height="766"></canvas>
              <div class="aplCustomPaddleEditorPreviewLabels">
                <span>Front</span>
                <span>Back</span>
              </div>
            </div>
            <div class="aplCustomPaddleEditorWorkspace">
              <div class="aplCustomPaddleEditorToolbar">
                <button type="button" class="aplCustomPaddleEditorTool" data-editor-delete title="Delete">🗑</button>
                <button type="button" class="aplCustomPaddleEditorTool" data-editor-rotate-left title="Rotate left">⟲</button>
                <button type="button" class="aplCustomPaddleEditorTool" data-editor-rotate-right title="Rotate right">⟳</button>
                <button type="button" class="aplCustomPaddleEditorTool" data-editor-zoom-out title="Zoom out">−</button>
                <button type="button" class="aplCustomPaddleEditorTool" data-editor-zoom-in title="Zoom in">+</button>
                <button type="button" class="aplCustomPaddleEditorTool aplCustomPaddleEditorTool--confirm" data-editor-done title="Done">✓</button>
              </div>
              <div class="aplCustomPaddleEditorCanvasWrap" data-lenis-prevent>
                <label class="aplCustomPaddleEditorColorBubble" title="Choose background color">
                  <span class="aplCustomPaddleEditorColorBubble__swatch" data-editor-color-swatch></span>
                  <span class="aplCustomPaddleEditorColorBubble__text">BG</span>
                  <input type="color" value="${getResolvedFillColor(side) || DEFAULT_EDITOR_BG_COLOR}" data-editor-bg-color>
                </label>
                <div class="aplCustomPaddleCropStage" data-custom-paddle-crop-stage>
                  <img class="aplCustomPaddleCropImage" data-custom-paddle-crop-image alt="">
                  <div class="aplCustomPaddleCropBox" data-custom-paddle-crop-box>
                    <span class="aplCustomPaddleCropShape" data-custom-paddle-crop-shape aria-hidden="true"></span>
                    <span class="aplCustomPaddleCropHandle aplCustomPaddleCropHandle--nw" data-editor-resize="nw"></span>
                    <span class="aplCustomPaddleCropHandle aplCustomPaddleCropHandle--ne" data-editor-resize="ne"></span>
                    <span class="aplCustomPaddleCropHandle aplCustomPaddleCropHandle--sw" data-editor-resize="sw"></span>
                    <span class="aplCustomPaddleCropHandle aplCustomPaddleCropHandle--se" data-editor-resize="se"></span>
                    <span class="aplCustomPaddleCropBoxCenter"></span>
                  </div>
                </div>
              </div>
              <div class="aplCustomPaddleEditorFooter">
                <p class="aplCustomPaddleEditorHelp">Drag the crop area, use the handles to resize it, and scroll inside the editor to zoom the image.</p>
              </div>
            </div>
          </div>
        </div>
      `;

      if ($.fancybox) {
        $.fancybox.open({
          src: adjustorMarkup,
          type: "html",
          touch: false,
          smallBtn: false,
          afterShow: function (instance, current) {
            const $content = current.$content;
            const renderEditor = () => {
              drawEditorViewport($content, editorState.side);
              syncBackgroundProperties();
            };

            renderEditor();

            $content.on("click", "[data-editor-zoom-in]", function () {
              imageState.transforms[editorState.side].scale += 0.12;
              renderEditor();
              redrawAll();
            });

            $content.on("click", "[data-editor-zoom-out]", function () {
              imageState.transforms[editorState.side].scale = Math.max(
                0.12,
                imageState.transforms[editorState.side].scale - 0.12,
              );
              renderEditor();
              redrawAll();
            });

            $content.on("click", "[data-editor-rotate-left]", function () {
              imageState.transforms[editorState.side].rotation -= 90;
              renderEditor();
              redrawAll();
            });

            $content.on("click", "[data-editor-rotate-right]", function () {
              imageState.transforms[editorState.side].rotation += 90;
              renderEditor();
              redrawAll();
            });

            $content.on("click", "[data-editor-delete]", function () {
              const currentSide = editorState.side;
              clearCustomPaddleSide(currentSide);
              $.fancybox.close();
            });

            $content.on("click", "[data-editor-done]", function () {
              redrawAll();
              $.fancybox.close();
            });

            $content.on("input change", "[data-editor-bg-color]", function () {
              imageState.transforms[editorState.side].bgColor =
                $(this).val() || "transparent";
              renderEditor();
              redrawAll();
            });

            const clampCropRect = (side) => {
              const cropRect = ensureCropRect(side);
              const cropHeightRatio = getEditorCropHeightRatio(side);
              cropRect.width = Math.max(
                140,
                Math.min(cropRect.width, EDITOR_STAGE_SIZE - 20),
              );
              cropRect.height = cropRect.width * cropHeightRatio;

              if (cropRect.height > EDITOR_STAGE_SIZE - 20) {
                cropRect.height = EDITOR_STAGE_SIZE - 20;
                cropRect.width = cropRect.height / cropHeightRatio;
              }

              if (cropRect.height < 140) {
                cropRect.height = 140;
                cropRect.width = cropRect.height / cropHeightRatio;
              }

              cropRect.x = Math.max(0, Math.min(cropRect.x, EDITOR_STAGE_SIZE - cropRect.width));
              cropRect.y = Math.max(0, Math.min(cropRect.y, EDITOR_STAGE_SIZE - cropRect.height));
            };

            const handlePointerMove = (pageX, pageY) => {
              if (!editorState.interaction) {
                return;
              }

              const deltaX = pageX - editorState.lastPointerX;
              const deltaY = pageY - editorState.lastPointerY;

              editorState.lastPointerX = pageX;
              editorState.lastPointerY = pageY;
              const cropRect = ensureCropRect(editorState.side);
              const cropHeightRatio = getEditorCropHeightRatio(editorState.side);

              if (editorState.interaction === "move") {
                cropRect.x += deltaX;
                cropRect.y += deltaY;
              } else {
                const previousCenterY = cropRect.y + cropRect.height / 2;
                const previousCenterX = cropRect.x + cropRect.width / 2;
                const previousRight = cropRect.x + cropRect.width;

                if (editorState.interaction.indexOf("e") !== -1) {
                  cropRect.width += deltaX;
                }

                if (editorState.interaction.indexOf("w") !== -1) {
                  cropRect.x += deltaX;
                  cropRect.width -= deltaX;
                }

                if (
                  editorState.interaction.indexOf("e") === -1 &&
                  editorState.interaction.indexOf("w") === -1
                ) {
                  if (editorState.interaction.indexOf("n") !== -1) {
                    cropRect.height -= deltaY;
                  }

                  if (editorState.interaction.indexOf("s") !== -1) {
                    cropRect.height += deltaY;
                  }

                  cropRect.width = cropRect.height / cropHeightRatio;
                }

                cropRect.height = cropRect.width * cropHeightRatio;

                if (editorState.interaction.indexOf("w") !== -1) {
                  cropRect.x = previousRight - cropRect.width;
                } else if (
                  editorState.interaction.indexOf("e") === -1 &&
                  editorState.interaction.indexOf("w") === -1
                ) {
                  cropRect.x = previousCenterX - cropRect.width / 2;
                }

                cropRect.y = previousCenterY - cropRect.height / 2;
              }

              clampCropRect(editorState.side);
              renderEditor();
              redrawAll();
            };

            const cropStage = $content.find("[data-custom-paddle-crop-stage]");
            const cropBox = $content.find("[data-custom-paddle-crop-box]");

            cropStage.on("wheel", function (event) {
              event.preventDefault();
              const delta = event.originalEvent.deltaY;
              const currentScale = imageState.transforms[editorState.side].scale || 1;

              imageState.transforms[editorState.side].scale = Math.max(
                0.12,
                Math.min(4, currentScale + (delta < 0 ? 0.08 : -0.08)),
              );

              renderEditor();
              redrawAll();
            });

            cropBox.on("mousedown touchstart", function (event) {
              const pointer =
                event.type === "touchstart" ? event.originalEvent.touches[0] : event;
              const resizeHandle = $(event.target).closest("[data-editor-resize]");
              editorState.interaction = resizeHandle.length
                ? String(resizeHandle.data("editor-resize") || "")
                : "move";
              editorState.lastPointerX = pointer.pageX;
              editorState.lastPointerY = pointer.pageY;
              event.preventDefault();
              event.stopPropagation();
            });

            $(document)
              .off("mousemove.aplPaddleEditor touchmove.aplPaddleEditor mouseup.aplPaddleEditor touchend.aplPaddleEditor")
              .on("mousemove.aplPaddleEditor", function (event) {
                handlePointerMove(event.pageX, event.pageY);
              })
              .on("touchmove.aplPaddleEditor", function (event) {
                const touch = event.originalEvent.touches[0];

                if (touch) {
                  handlePointerMove(touch.pageX, touch.pageY);
                }
              })
              .on("mouseup.aplPaddleEditor touchend.aplPaddleEditor", function () {
                editorState.interaction = "";
              });
          },
          afterClose: function () {
            editorState.interaction = "";
            $(document).off(
              "mousemove.aplPaddleEditor touchmove.aplPaddleEditor mouseup.aplPaddleEditor touchend.aplPaddleEditor",
            );
          },
        });
      }
    };

    $(document).on("click", "[data-custom-paddle-adjust-trigger]", function () {
      const side = String($(this).data("custom-paddle-adjust-trigger") || "");

      if (side) {
        openAdjustor(side);
      }
    });

    $(document).on("click", "[data-custom-paddle-remove-trigger]", function () {
      const side = String($(this).data("custom-paddle-remove-trigger") || "");

      if (side) {
        clearCustomPaddleSide(side);
      }
    });

    window.APLCustomPaddle = window.APLCustomPaddle || {};
    window.APLCustomPaddle.prepareManualCanvasFormSubmission = (form) => {
      const $form = $(form);
      const frontInput = form?.querySelector('[data-custom-paddle-upload="front"]');
      const previewInput = form?.querySelector(
        '[data-custom-paddle-generated-file="preview"]',
      );
      const stage = $form
        .closest(".product_section")
        .find("[data-custom-paddle-stage]")
        .first();

      if (!(frontInput && frontInput.files && frontInput.files.length)) {
        showUploadToast("Front image is required.", "error");
        frontInput?.focus();
        return Promise.reject(new Error("Front image is required."));
      }

      if (!previewInput) {
        showUploadToast("Final preview input is missing.", "error");
        return Promise.reject(new Error("Final preview input is missing."));
      }

      showCartProgressToast();

      return canvasToFile(
        buildCompositePreviewCanvas(stage),
        `apl-custom-preview-${Date.now()}.png`,
      ).then((previewFile) => {
        assignFileToInput(previewInput, previewFile);
        syncCustomPaddleFileNameProperty(form, "preview", previewFile.name);
        form.setAttribute("enctype", "multipart/form-data");
        form.setAttribute("encoding", "multipart/form-data");
        return form;
      });
    };

    const syncMediaDebugPanel = () => {
      const panel = $(".aplCustomPaddleMediaDebugger, .aplCustomCoverMediaDebugger");

      if (!panel.length) {
        return;
      }

      ["front", "back"].forEach((side) => {
        ["x", "y", "width", "height"].forEach((key) => {
          panel
            .find(`[data-media-debug-value="${side}-${key}"]`)
            .text(Math.round(activeMediaDebugSettings[side][key]));
          panel
            .find(`[data-media-debug-range="${side}-${key}"]`)
            .val(activeMediaDebugSettings[side][key]);
        });
      });
    };

    const ensureMediaDebugPanel = () => {
      $(".aplCustomPaddleMediaDebugger, .aplCustomCoverMediaDebugger").remove();

      if (!isCoverTemplate) {
        return;
      }

      const debugMarkup = `
        <div class="aplCustomCoverMediaDebugger">
          <div class="aplCustomPaddleMediaDebugger__title">Cover Preview Adjustor</div>
          ${["front", "back"]
            .map(
              (side) => `
                <div class="aplCustomPaddleMediaDebugger__group">
                  <div class="aplCustomPaddleMediaDebugger__heading">${side}</div>
                  ${["x", "y", "width", "height"]
                    .map(
                      (key) => `
                        <label class="aplCustomPaddleMediaDebugger__field">
                          <span>${key.toUpperCase()}: <strong data-media-debug-value="${side}-${key}">0</strong></span>
                          <input type="range" min="-300" max="300" step="1" value="0" data-media-debug-range="${side}-${key}">
                        </label>
                      `,
                    )
                    .join("")}
                </div>
              `,
            )
            .join("")}
        </div>
      `;

      $("body").append(debugMarkup);
    };

    const firstStage = customStages.first();
    const frontMaskUrl = firstStage.data("custom-paddle-front-mask");
    const backMaskUrl = firstStage.data("custom-paddle-back-mask");
    const coverRegionsMaskUrl = firstStage.data("custom-cover-regions-mask");
    const topLineMaskUrl = firstStage.data("custom-paddle-top-line-mask");
    const bottomLineMaskUrl = firstStage.data("custom-paddle-bottom-line-mask");

    if (frontMaskUrl) {
      frontFilledMaskImage.onload = function () {
        filledMaskBounds.front = getMaskBounds(frontFilledMaskImage);
        editorMaskDataUrls.front = buildEditorMaskDataUrl(
          frontFilledMaskImage,
          filledMaskBounds.front,
        );
        redrawAll();
      };
      frontFilledMaskImage.src = frontMaskUrl;
    }

    if (backMaskUrl) {
      backFilledMaskImage.onload = function () {
        filledMaskBounds.back = getMaskBounds(backFilledMaskImage);
        editorMaskDataUrls.back = buildEditorMaskDataUrl(
          backFilledMaskImage,
          filledMaskBounds.back,
        );
        redrawAll();
      };
      backFilledMaskImage.src = backMaskUrl;
    }

    if (coverRegionsMaskUrl) {
      coverRegionsMaskImage.onload = function () {
        const coverRegions = getMaskRegions(coverRegionsMaskImage);
        coverRegionBounds.front = coverRegions?.left || null;
        coverRegionBounds.back = coverRegions?.right || null;
        editorMaskDataUrls.front = buildEditorMaskDataUrl(
          coverRegionsMaskImage,
          coverRegionBounds.front,
        );
        editorMaskDataUrls.back = buildEditorMaskDataUrl(
          coverRegionsMaskImage,
          coverRegionBounds.back,
        );
        redrawAll();
      };
      coverRegionsMaskImage.src = coverRegionsMaskUrl;
    }

    if (topLineMaskUrl) {
      topLineMaskImage.onload = function () {
        textMaskBounds.top = getMaskRegions(topLineMaskImage);
        redrawAll();
      };
      topLineMaskImage.src = topLineMaskUrl;
    }

    if (bottomLineMaskUrl) {
      bottomLineMaskImage.onload = function () {
        textMaskBounds.bottom = getMaskRegions(bottomLineMaskImage);
        redrawAll();
      };
      bottomLineMaskImage.src = bottomLineMaskUrl;
    }

    $("[data-product-form]").each(function () {
      if (
        String($(this).data("has-custom-paddle-image")) === "true" ||
        String($(this).data("has-manual-cover")) === "true"
      ) {
        $(this)
          .closest(".product_section")
          .find(".product-personalizer")
          .hide();
      }
    });

    $(document)
      .off("input.aplCoverMediaDebug")
      .on("input.aplCoverMediaDebug", "[data-media-debug-range]", function () {
        if (!isCoverTemplate) {
          return;
        }

        const dataKey = String($(this).data("media-debug-range") || "");
        const parts = dataKey.split("-");

        if (parts.length !== 2) {
          return;
        }

        const side = parts[0];
        const key = parts[1];

        if (!activeMediaDebugSettings[side] || typeof activeMediaDebugSettings[side][key] === "undefined") {
          return;
        }

        activeMediaDebugSettings[side][key] = Number($(this).val()) || 0;
        syncMediaDebugPanel();
        redrawAll();
      });

    ensureMediaDebugPanel();
    syncBackgroundProperties();
    redrawAll();
  };

  // ===PRODUCT TOP NOTICE CAROUSEL====
  const productTopNoticeCarousel = () => {
    const noticeArrowSvg = `
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $("[data-product-top-notice-carousel]").each(function () {
      const currentCarousel = $(this);
      const slideCount =
        Number(currentCarousel.data("product-top-notice-count")) || 0;

      if (
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled") ||
        typeof $.fn.flickity !== "function"
      ) {
        return;
      }

      if (slideCount <= 1) {
        currentCarousel
          .closest("[data-product-top-notice-wrap]")
          .addClass("is-single-slide");
        return;
      }

      currentCarousel.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: false,
        draggable: true,
        cellAlign: "center",
        contain: true,
        autoPlay: 4000,
        pauseAutoPlayOnHover: false,
      });
    });

    $(document).on("click", "[data-product-top-notice-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-top-notice-wrap]")
        .find("[data-product-top-notice-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-product-top-notice-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-top-notice-wrap]")
        .find("[data-product-top-notice-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    $("[data-product-top-notice-arrow]").each(function () {
      const currentButton = $(this);

      if (!currentButton.find("svg").length) {
        currentButton.html(noticeArrowSvg);
      }
    });
  };

  // ===PRODUCT PAGE CUSTOM UI====
  const productPageCustomUI = () => {
    $(document)
      .off("click.aplAccordionSync")
      .on("click.aplAccordionSync", ".aplProductAccordionTrigger", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const currentTrigger = $(this);
        const currentItem = currentTrigger.closest(".aplProductAccordionItem");
        const currentContent = currentItem.find(".aplProductAccordionContent").first();
        const willOpen = !currentItem.hasClass("is-open");

        currentItem.toggleClass("is-open", willOpen);
        currentItem.toggleClass("tab--open", willOpen);

        if (willOpen) {
          currentContent.stop(true, true).slideDown(220);
        } else {
          currentContent.stop(true, true).slideUp(220);
        }
      });

    $(".aplProductAccordionItem").each(function () {
      const currentItem = $(this);
      const currentContent = currentItem.find(".aplProductAccordionContent").first();

      currentItem.removeClass("is-open tab--open");
      currentContent.stop(true, true).hide();
    });

    $("[data-product-addons-carousel]").each(function () {
      const currentCarousel = $(this);

      if (
        !currentCarousel.length ||
        currentCarousel.hasClass("flickity-enabled") ||
        typeof $.fn.flickity !== "function"
      ) {
        return;
      }

      currentCarousel.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        cellAlign: "left",
        draggable: true,
        groupCells: "100%",
      });

      currentCarousel.on("settle.flickity", function () {
        currentCarousel.flickity("resize");
      });
    });

    $(document).on("click", "[data-product-addons-prev]", function () {
      const currentCarousel = $(this)
        .closest(".aplProductAddOns")
        .find("[data-product-addons-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-product-addons-next]", function () {
      const currentCarousel = $(this)
        .closest(".aplProductAddOns")
        .find("[data-product-addons-carousel]");

      if (
        typeof $.fn.flickity === "function" &&
        currentCarousel.hasClass("flickity-enabled")
      ) {
        currentCarousel.flickity("next");
      }
    });

    const parseBulkMoneyToken = (value) => {
      const source = String(value || "");
      const tokenMatch = source.match(/(?:Rs\.?\s*|[$€£])?\s*\d[\d,]*(?:\.\d+)?/i);

      if (!tokenMatch) {
        return null;
      }

      const token = tokenMatch[0].trim();
      const numericMatch = token.match(/\d[\d,]*(?:\.\d+)?/);

      if (!numericMatch) {
        return null;
      }

      const numericPart = numericMatch[0];
      const valueNumber = Number(numericPart.replace(/,/g, ""));
      const decimalCount = numericPart.includes(".") ? numericPart.split(".")[1].length : 0;
      const prefix = token.slice(0, numericMatch.index || 0);
      const suffix = token.slice((numericMatch.index || 0) + numericPart.length);

      if (Number.isNaN(valueNumber)) {
        return null;
      }

      return {
        value: valueNumber,
        decimals: decimalCount,
        prefix,
        suffix,
      };
    };

    const formatBulkMoney = (amount, source) => {
      const parsed = parseBulkMoneyToken(source);

      if (!parsed || Number.isNaN(amount)) {
        return "";
      }

      const fixed = Number(amount).toFixed(parsed.decimals);
      const parts = fixed.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return `${parsed.prefix}${parts.join(".")}${parsed.suffix}`.trim();
    };

    const initBulkQuantityPricing = (scope) => {
      const root = scope instanceof Element ? scope : document;

      root.querySelectorAll(".bulkCustomProductSection .product_section").forEach((section) => {
        if (section.dataset.aplBulkPricingReady === "true") {
          return;
        }

        const quantityInput = section.querySelector('.purchase-details__quantity input[name="quantity"]');
        const customQuantityInput = section.querySelector("[data-bulk-quantity-input]");
        const tierButtons = Array.from(section.querySelectorAll("[data-bulk-tier-trigger]"));
        const pricingCards = Array.from(section.querySelectorAll("[data-bulk-pricing-card]"));
        const priceTarget = section.querySelector("[data-bulk-total-price]");
        const priceTarget2 = section.querySelector("[data-bulk-total-price2]");
        const priceSource = section.querySelector(".productPriceArea .price-ui");
        const variantSelection = section.querySelector("[data-variant-selection]");
        const variantData = section.querySelector("[data-bulk-pricing-variants]");
        const variants = variantData ? JSON.parse(variantData.textContent) : [];
        const cartVariantData = section.querySelector("[data-bulk-cart-variants]");
        const cartVariants = cartVariantData ? JSON.parse(cartVariantData.textContent) : [];
        const cartVariantInput = section.querySelector("[data-bulk-cart-variant]");
        const form = quantityInput?.closest("form");
        const addButton = form?.querySelector(".button--add-to-cart");
        const addButtonLabel = addButton?.querySelector(".text");
        const originalAddLabel = addButtonLabel?.textContent;

        const getSelectedVariant = () => {
          const variantId = section.querySelector('[data-variants]')?.value;
          return variants.find((variant) => String(variant.id) === String(variantId));
        };

        const getMaterial = (variant) => {
          const title = (variant?.options || []).join(" ").toLowerCase();
          if (/carbon|\bpro\b/.test(title)) return "carbon";
          if (/fiberglass|fiber\s*glass|\bcomp\b/.test(title)) return "fiberglass";
          if (/composite|\brec\b/.test(title)) return "composite";
          return null;
        };

        const getBulkVariant = (material, tierCard) => {
          if (!material || !tierCard) return null;
          const minimum = Number(tierCard.dataset.tierQuantity);
          return cartVariants.find((variant) =>
            getMaterial(variant) === material &&
            Number(variant.options[1]?.split("-")[0]) === minimum
          );
        };

        const formatTierMoney = (amount) => {
          return new Intl.NumberFormat(document.documentElement.lang || "en", {
            style: "currency",
            currency: window.Shopify?.currency?.active || "USD",
          }).format(amount);
        };

        if (!quantityInput || !customQuantityInput || !tierButtons.length) {
          if (priceSource && priceTarget) {
            priceTarget.innerHTML = priceSource.innerHTML;
            priceTarget2.innerHTML = priceSource.innerHTML;
          }
          section.dataset.aplBulkPricingReady = "true";
          return;
        }

        const getTierByQuantity = (quantity) => {
          let matchedTier = null;

          tierButtons.forEach((button) => {
            const tierQuantity = Number(button.dataset.tierQuantity || 0);

            if (quantity >= tierQuantity) {
              matchedTier = button;
            }
          });

          return matchedTier;
        };

        const syncCardStates = (activeIndex) => {
          tierButtons.forEach((button) => {
            button.classList.toggle("is-active", button.dataset.tierIndex === activeIndex);
          });

          pricingCards.forEach((card) => {
            card.classList.toggle("is-active", card.dataset.tierIndex === activeIndex);
          });
        };

        const syncTotalPrice = () => {
          if (!priceTarget) {
            return;
          }

          const quantity = Number(customQuantityInput.value);
          const validQuantity = customQuantityInput.value !== "" && Number.isInteger(quantity) && quantity > 0;
          const selectedVariant = getSelectedVariant();
          const material = getMaterial(selectedVariant);
          const activeTier = getTierByQuantity(quantity);
          const activeIndex = activeTier ? activeTier.dataset.tierIndex : null;
          const activePricingCard = pricingCards.find((card) => card.dataset.tierIndex === activeIndex);
          const inquiryOnly = activePricingCard?.dataset.tierInquire === "true";

          pricingCards.forEach((card) => {
            card.querySelectorAll("[data-bulk-material-price]").forEach((cell) => {
              const cellMaterial = cell.dataset.bulkMaterialPrice;
              const bulkVariant = getBulkVariant(cellMaterial, card);
              const unitPrice = cartVariantInput
                ? bulkVariant?.price / 100
                : Number(card.dataset[`tier${cellMaterial[0].toUpperCase()}${cellMaterial.slice(1)}`]);
              cell.innerHTML = card.dataset.tierInquire === "true" ? "Inquire"
                : Number.isFinite(unitPrice) && unitPrice > 0
                  ? `${formatTierMoney(unitPrice)} <span>/ paddle</span>` : "Unavailable";
              cell.classList.toggle("is-selected", validQuantity && card === activePricingCard && cellMaterial === material);
            });
          });

          if (addButtonLabel) addButtonLabel.textContent = inquiryOnly ? "Inquire" : originalAddLabel;
          if (addButton) {
            addButton.toggleAttribute("data-bulk-inquiry", inquiryOnly);
            addButton.dataset.label = inquiryOnly ? "Inquire" : originalAddLabel;
            $(addButton).data("label", inquiryOnly ? "Inquire" : originalAddLabel);
          }

          syncCardStates(activeIndex);

          const bulkVariant = getBulkVariant(material, activePricingCard);
          if (cartVariantInput) {
            cartVariantInput.value = !validQuantity || inquiryOnly ? "" : activePricingCard
              ? (bulkVariant?.available ? bulkVariant.id : "")
              : selectedVariant?.id || "";
          }

          if (addButton) {
            addButton.disabled = !validQuantity || (!inquiryOnly && (!selectedVariant?.available || (cartVariantInput && !cartVariantInput.value)));
            addButton.classList.toggle("disabled", addButton.disabled);
          }

          if (!validQuantity) {
            priceTarget.innerHTML = formatTierMoney(0);
            priceTarget2.innerHTML = formatTierMoney(0);
            return;
          }

          if (inquiryOnly) {
            priceTarget.textContent = "Inquire";
            priceTarget2.textContent = "Inquire";
            return;
          }

          if (!selectedVariant || !material) {
            priceTarget.textContent = "Choose paddle type";
            priceTarget2.textContent = "";
            return;
          }

          if (activePricingCard) {
            const unitPrice = cartVariantInput
              ? bulkVariant?.price / 100
              : Number(activePricingCard.dataset[`tier${material[0].toUpperCase()}${material.slice(1)}`]);
            if (cartVariantInput && !cartVariantInput.value) {
              priceTarget.textContent = "Bulk pricing unavailable";
              priceTarget2.textContent = "Bulk pricing unavailable";
              return;
            }
            if (Number.isFinite(unitPrice) && unitPrice > 0) {
              priceTarget.innerHTML = formatTierMoney(unitPrice * quantity);
              priceTarget2.innerHTML = formatTierMoney(unitPrice * quantity);
              return;
            }
          }

          priceTarget.innerHTML = formatTierMoney(selectedVariant.price / 100 * quantity);
          priceTarget2.innerHTML = formatTierMoney(selectedVariant.price / 100 * quantity);
        };

        const setQuantity = (value, fromTier) => {
          const nextQuantity = value === "" ? "" : value;
          quantityInput.value = nextQuantity;
          customQuantityInput.value = nextQuantity;

          if (fromTier) {
            customQuantityInput.dataset.bulkTierLocked = "true";
          } else {
            customQuantityInput.dataset.bulkTierLocked = "false";
          }

          syncTotalPrice();
        };

        const syncFromQuantityInput = () => {
          customQuantityInput.value = quantityInput.value;
          syncTotalPrice();
        };

        tierButtons.forEach((button) => {
          button.addEventListener("click", () => {
            setQuantity(button.dataset.tierQuantity, true);
          });
        });

        customQuantityInput.addEventListener("input", () => {
          setQuantity(customQuantityInput.value, false);
        });

        customQuantityInput.addEventListener("change", () => {
          setQuantity(customQuantityInput.value, false);
        });

        quantityInput.addEventListener("input", syncFromQuantityInput);
        quantityInput.addEventListener("change", syncFromQuantityInput);

        section.querySelectorAll("[data-update-quantity]").forEach((button) => {
          button.addEventListener("click", () => {
            window.setTimeout(syncFromQuantityInput, 0);
          });
        });

        if (variantSelection) {
          variantSelection.addEventListener("variant-change", () => {
            window.setTimeout(syncTotalPrice, 0);
            window.setTimeout(syncTotalPrice, 80);
          });
        }

        form.aplPrepareBulkCart = () => {
          setQuantity(customQuantityInput.value, false);
          return !addButton.disabled && (!cartVariantInput || Boolean(cartVariantInput.value));
        };

        const openBulkInquiry = (event) => {
          setQuantity(customQuantityInput.value, false);
          if (addButton.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          const tier = getTierByQuantity(Number(quantityInput.value));
          const card = pricingCards.find((item) => item.dataset.tierIndex === tier?.dataset.tierIndex);
          if (card?.dataset.tierInquire !== "true" && cartVariantInput && !cartVariantInput.value) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const warning = form?.querySelector(".cart-warning");
            if (warning) warning.textContent = "Please select an available paddle type.";
            return;
          }
          if (card?.dataset.tierInquire !== "true") return;
          event.preventDefault();
          event.stopImmediatePropagation();
          document.querySelector('[data-bulk-mockup-trigger]')?.click();
        };
        form?.addEventListener("submit", openBulkInquiry, true);
        addButton?.addEventListener("click", openBulkInquiry, true);

        if (!Number(quantityInput.value) || Number(quantityInput.value) <= 1) {
          setQuantity(tierButtons[0].dataset.tierQuantity, true);
        } else {
          setQuantity(quantityInput.value, false);
        }

        if (priceSource && priceSource.dataset.aplBulkPriceObserved !== "true") {
          priceSource.dataset.aplBulkPriceObserved = "true";

          const observer = new MutationObserver(() => {
            syncTotalPrice();
          });

          observer.observe(priceSource, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        section.dataset.aplBulkPricingReady = "true";
      });
    };

    initBulkQuantityPricing(document);

    document.querySelectorAll(".bulkCustomProductSection .aplProductAddOnsCheckbox").forEach((input) => {
      const syncCard = () => {
        const card = input.closest(".aplProductAddOnsCard--bulk");

        if (!card) {
          return;
        }

        card.classList.toggle("is-selected", input.checked);
      };

      if (input.dataset.aplBulkAddonBound === "true") {
        syncCard();
        return;
      }

      input.dataset.aplBulkAddonBound = "true";
      input.addEventListener("change", syncCard);
      syncCard();
    });

    document.querySelectorAll(".bulkCustomProductSection [data-bulk-sample-trigger]").forEach((button) => {
      if (button.dataset.aplBulkSampleReady === "true") {
        return;
      }

      button.dataset.aplBulkSampleReady = "true";
      button.addEventListener("click", (event) => {
        event.preventDefault();

        const productSection = button.closest(".product_section");
        const form = button.closest("form");
        const addToCartButton = form?.querySelector(".button--add-to-cart");

        if (!form || !addToCartButton) {
          return;
        }

        const quantityInput = form.querySelector('input[name="quantity"]');
        const customQuantityInput = productSection?.querySelector("[data-bulk-quantity-input]");

        if (quantityInput) {
          quantityInput.value = 1;
          quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        if (customQuantityInput) {
          customQuantityInput.value = 1;
          customQuantityInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        addToCartButton.click();
      });
    });
  };

  const paddleTypeInfoPopup = () => {
    const syncStats = (scope = document) => {
      scope.querySelectorAll(".swatchOption--paddle-type").forEach((fieldSet) => {
        const statsNode = fieldSet.querySelector("[data-paddle-type-stats]");
        const checkedInput = fieldSet.querySelector('[data-variant-option-value]:checked');

        if (!statsNode || !checkedInput) {
          return;
        }

        const selectedValue = (checkedInput.value || "").toLowerCase();
        let statsText = "";

        if (selectedValue.includes("rec")) {
          statsText = statsNode.dataset.paddleTypeStatsRec || "";
        } else if (selectedValue.includes("comp")) {
          statsText = statsNode.dataset.paddleTypeStatsComp || "";
        } else if (selectedValue.includes("pro")) {
          statsText = statsNode.dataset.paddleTypeStatsPro || "";
        }

        statsNode.textContent = statsText;
      });
    };

    const renderLegend = (legendNode) => {
      if (!legendNode) {
        return;
      }

      const legendLabel = legendNode.dataset.paddleTypeLabel || "PADDLE TYPE";
      const infoImage = legendNode.dataset.paddleTypeInfoImage || "";

      legendNode.innerHTML = `
        <span class="aplPaddleTypeLegendText">${legendLabel}</span>
        ${
          infoImage
            ? `<a
                href="${infoImage}"
                class="aplPaddleTypeInfoButton"
                data-fancybox="paddle-type-info"
                title="${legendLabel} info"
                aria-label="${legendLabel} info"
              >
                <span class="icon" data-icon="info">
                  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 45.999 45.999" fill="currentColor"><path d="M39.264 6.736c-8.982-8.981-23.545-8.982-32.528 0s-8.981 23.545 0 32.528c8.982 8.98 23.545 8.981 32.528 0 8.981-8.983 8.98-23.545 0-32.528M25.999 33a3 3 0 1 1-6 0V21a3 3 0 1 1 6 0zm-3.053-17.128c-1.728 0-2.88-1.224-2.844-2.735-.036-1.584 1.116-2.771 2.879-2.771 1.764 0 2.88 1.188 2.917 2.771-.001 1.511-1.152 2.735-2.952 2.735"/></svg>
                </span>
              </a>`
            : ""
        }
      `;
    };

    const initLegend = (legendNode) => {
      if (!legendNode) {
        return;
      }

      renderLegend(legendNode);

      if (legendNode.dataset.aplPaddleTypeObserved === "true") {
        return;
      }

      const observer = new MutationObserver(() => {
        const hasLegendText = legendNode.querySelector(".aplPaddleTypeLegendText");
        const needsInfoButton = Boolean(legendNode.dataset.paddleTypeInfoImage);
        const hasInfoButton = legendNode.querySelector(".aplPaddleTypeInfoButton");

        if (!hasLegendText || (needsInfoButton && !hasInfoButton)) {
          renderLegend(legendNode);
        }
      });

      observer.observe(legendNode, {
        childList: true,
        subtree: true,
      });

      legendNode.dataset.aplPaddleTypeObserved = "true";
    };

    const initAllLegends = () => {
      document
        .querySelectorAll('[data-variant-option-static="true"]')
        .forEach(initLegend);
      syncStats(document);
    };

    initAllLegends();

    $(document)
      .off("change.aplPaddleTypeInfo click.aplPaddleTypeInfo")
      .on(
        "change.aplPaddleTypeInfo click.aplPaddleTypeInfo",
        '.swatchOption--paddle-type [data-variant-option-value], .swatchOption--paddle-type [data-variant-option-value-label]',
        function () {
          window.setTimeout(initAllLegends, 0);
          window.setTimeout(initAllLegends, 80);
          window.setTimeout(() => syncStats(document), 0);
          window.setTimeout(() => syncStats(document), 80);
        },
      );
  };

  const bulkEnquiriesStickyBar = () => {
    const stickyBar = document.querySelector("[data-apl-sticky-collection-bar]");

    if (!stickyBar) {
      return;
    }

    const scrollThreshold = Number(stickyBar.dataset.scrollThreshold || 800);

    const toggleBar = () => {
      const shouldShow = window.scrollY >= scrollThreshold;
      stickyBar.classList.toggle("is-visible", shouldShow);
    };

    toggleBar();
    window.addEventListener("scroll", toggleBar, { passive: true });
    window.addEventListener("resize", toggleBar);
  };

  const bulkMockupModal = () => {
    const modal = document.querySelector("[data-bulk-mockup-modal]");

    if (!modal) {
      return;
    }

    const openModal = () => {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("aplBulkMockupModalOpen"); 
      $("body, html").addClass("hideScroll isMobileMenuOpen");
    };

    const closeModal = () => {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("aplBulkMockupModalOpen");
      $("body, html").remove("hideScroll isMobileMenuOpen");
    };

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-bulk-mockup-trigger]");

      if (trigger) {
        event.preventDefault();
        openModal();
        return;
      }

      if (event.target.closest("[data-bulk-mockup-close]")) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });
  };

  // ===AUTOPLAY VIDEOS====
  const autoplaySectionVideos = () => {
    const playVideo = (videoElement) => {
      if (!videoElement) {
        return;
      }

      videoElement.muted = true;
      videoElement.defaultMuted = true;
      videoElement.setAttribute("muted", "muted");
      videoElement.setAttribute("playsinline", "playsinline");
      videoElement.setAttribute("autoplay", "autoplay");

      const playPromise = videoElement.play();

      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    };

    $("[data-autoplay-video]").each(function () {
      const currentVideo = this;

      if (currentVideo.readyState >= 2) {
        playVideo(currentVideo);
      } else {
        currentVideo.addEventListener(
          "loadeddata",
          function handleLoadedData() {
            playVideo(currentVideo);
            currentVideo.removeEventListener("loadeddata", handleLoadedData);
          },
        );
      }
    });
  };

  // ===FREE GIFT CART SYNC====
  const syncFreeGiftCart = () => {
    const freeGiftVariantId = Number(window.aplTheme?.freeGiftVariantId) || 0;
    let isSyncing = false;
    let statusTimeout = null;

    const ensureStatusNode = () => {
      let statusNode = document.querySelector("[data-apl-free-gift-status]");

      if (!statusNode) {
        statusNode = document.createElement("div");
        statusNode.className = "aplFreeGiftStatus";
        statusNode.setAttribute("data-apl-free-gift-status", "");
        document.body.appendChild(statusNode);
      }

      return $(statusNode);
    };

    const showStatus = (message) => {
      const statusNode = ensureStatusNode();

      clearTimeout(statusTimeout);
      statusNode.text(message).addClass("is-visible");
    };

    const hideStatus = () => {
      const statusNode = ensureStatusNode();

      clearTimeout(statusTimeout);
      statusTimeout = window.setTimeout(() => {
        statusNode.removeClass("is-visible");
      }, 700);
    };

    const refreshCartPageMarkup = () => {
      if (!$(".cart__form").length) {
        return;
      }

      $.ajax({
        dataType: "html",
        cache: false,
        url: "/cart",
        success: function (html) {
          const updatedForm = $(html).find(".cart__form");
          const emptyMessage = $(html).find(".cart__empty-cart-message");

          if (updatedForm.length) {
            $(".cart__form").replaceWith(updatedForm);
          }

          if (emptyMessage.length) {
            $(".cart__empty-cart-message").replaceWith(emptyMessage);
          }
        },
      });
    };

    const refreshCartViews = () => {
      if (typeof Shopify.theme.jsAjaxCart !== "undefined") {
        Shopify.theme.jsAjaxCart.updateView();
      }

      refreshCartPageMarkup();
    };

    const runSync = (options = {}) => {
      const syncDeferred = $.Deferred();

      if (!freeGiftVariantId || isSyncing) {
        syncDeferred.resolve();
        return syncDeferred.promise();
      }

      isSyncing = true;

      $.getJSON("/cart.js")
        .done(function (cart) {
          const giftItems = cart.items.filter((item) => {
            const hasGiftProperty =
              item.properties && item.properties._apl_free_gift === "true";
            return (
              Number(item.variant_id) === freeGiftVariantId || hasGiftProperty
            );
          });
          const nonGiftItems = cart.items.filter((item) => {
            const hasGiftProperty =
              item.properties && item.properties._apl_free_gift === "true";
            return (
              Number(item.variant_id) !== freeGiftVariantId && !hasGiftProperty
            );
          });

          if (nonGiftItems.length === 0 && giftItems.length === 0) {
            syncDeferred.resolve(cart);
            return;
          }

          if (nonGiftItems.length === 0 && giftItems.length > 0) {
            const updates = {};

            giftItems.forEach((item) => {
              updates[item.key] = 0;
            });

            $.ajax({
              type: "POST",
              url: "/cart/update.js",
              data: JSON.stringify({ updates: updates }),
              contentType: "application/json; charset=UTF-8",
              dataType: "json",
              success: function () {
                refreshCartViews();
                syncDeferred.resolve();
              },
              error: function (xhr) {
                syncDeferred.reject(xhr);
              },
            });

            return;
          }

          if (giftItems.length === 0) {
            if (options.showStatus) {
              showStatus("Adding Free Product");
            }

            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: JSON.stringify({
                id: freeGiftVariantId,
                quantity: 1,
                properties: {
                  _apl_free_gift: "true",
                },
              }),
              contentType: "application/json; charset=UTF-8",
              dataType: "json",
              success: function () {
                refreshCartViews();
                hideStatus();
                syncDeferred.resolve();
              },
              error: function (xhr) {
                hideStatus();
                syncDeferred.reject(xhr);
              },
            });

            return;
          }

          const updates = {};
          let hasUpdates = false;

          giftItems.forEach((item, index) => {
            const nextQuantity = index === 0 ? 1 : 0;

            if (Number(item.quantity) !== nextQuantity) {
              updates[item.key] = nextQuantity;
              hasUpdates = true;
            }
          });

          if (hasUpdates) {
            $.ajax({
              type: "POST",
              url: "/cart/update.js",
              data: JSON.stringify({ updates: updates }),
              contentType: "application/json; charset=UTF-8",
              dataType: "json",
              success: function () {
                refreshCartViews();
                syncDeferred.resolve();
              },
              error: function (xhr) {
                syncDeferred.reject(xhr);
              },
            });
          } else {
            syncDeferred.resolve(cart);
          }
        })
        .fail(function (xhr) {
          syncDeferred.reject(xhr);
        })
        .always(function () {
          isSyncing = false;
        });

      return syncDeferred.promise();
    };

    window.APLThemeHelpers = window.APLThemeHelpers || {};
    window.APLThemeHelpers.syncFreeGiftCart = runSync;

    if ($(".cart__form, [data-ajax-cart-content]").length) {
      runSync();
    }
  };

  // ===HOME PAGE SCROLL ANIMATIONS====
  const homePageScrollAnimations = () => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    const revealHeader = (sectionSelector, targetsSelector) => {
      gsap.utils.toArray(sectionSelector).forEach((section) => {
        const targets = section.querySelectorAll(targetsSelector);

        if (!targets.length) {
          return;
        }

        gsap.set(targets, {
          opacity: 0,
          y: 28,
        });

        gsap.to(targets, {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: "power3.out",
          stagger: 0.12,
          scrollTrigger: {
            trigger: section,
            start: "top 82%",
            once: true,
          },
        });
      });
    };

    const revealItems = (
      selector,
      triggerSelector = selector,
      start = "top 85%",
    ) => {
      gsap.utils.toArray(selector).forEach((item) => {
        const triggerItem = item.closest(triggerSelector) || item;

        gsap.set(item, {
          opacity: 0,
          y: 34,
        });

        gsap.to(item, {
          opacity: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          scrollTrigger: {
            trigger: triggerItem,
            start: start,
            once: true,
          },
        });
      });
    };

    const parallaxMedia = (selector, triggerSelector) => {
      gsap.utils.toArray(selector).forEach((item) => {
        const triggerItem = item.closest(triggerSelector) || item;

        gsap.fromTo(
          item,
          {
            yPercent: -8,
            scale: 1.08,
          },
          {
            yPercent: 8,
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: triggerItem,
              start: "top bottom",
              end: "bottom top",
              scrub: 1.1,
            },
          },
        );
      });
    };

    revealHeader(
      ".featuredCollectionSection",
      ".featured-collection__preheading, .featured-collection__title",
    );
    revealHeader(
      ".collectionTabsSection",
      ".collectionTabsSectionTitle, .collectionTabsNav",
    );
    revealHeader(
      ".differenceMediaSection",
      ".differenceMediaSectionPreheading, .differenceMediaSectionTitle, .differenceMediaSectionBottomTitle",
    );
    revealHeader(
      ".testimonialShowcaseSection",
      ".testimonialShowcaseSectionPreheading, .testimonialShowcaseSectionTitle",
    );
    revealHeader(
      ".movementGallerySection",
      ".movementGallerySectionPreheading, .movementGallerySectionTitle, .movementGallerySectionDescription",
    );

    revealItems(".featuredCollectionProductCard");
    revealItems(
      ".collectionTabsPanel.is-active .featuredCollectionProductCard",
      ".collectionTabsSection",
    );
    revealItems(".differenceMediaSectionFeature", ".differenceMediaSection");
    revealItems(
      ".testimonialShowcaseCard",
      ".testimonialShowcaseSection",
      "top 80%",
    );
    revealItems(".movementGalleryItem", ".movementGallerySection", "top 88%");

    parallaxMedia(
      ".featuredCollectionProductCard .image__container.product__imageContainer img",
      ".featuredCollectionProductCard",
    );
    parallaxMedia(
      ".differenceMediaSectionStoryImageWrap img",
      ".differenceMediaSectionStoryCard",
    );
    parallaxMedia(
      ".differenceMediaSectionVideo",
      ".differenceMediaSectionVideoBox",
    );
    parallaxMedia(".testimonialShowcaseVideo", ".testimonialShowcaseVideoCard");
    parallaxMedia(
      ".testimonialShowcaseVideoPlaceholder img",
      ".testimonialShowcaseVideoCard",
    );
    parallaxMedia(".movementGalleryImageWrap img", ".movementGalleryItem");

    gsap.utils
      .toArray(
        ".differenceMediaSectionToast, .testimonialShowcaseToast, .floatingToastSection",
      )
      .forEach((item) => {
        gsap.fromTo(
          item,
          {
            y: 20,
          },
          {
            y: -8,
            ease: "none",
            scrollTrigger: {
              trigger: item,
              start: "top bottom",
              end: "bottom top",
              scrub: 1.4,
            },
          },
        );
      });
  };

  // ===PRODUCT PAGE SCROLL ANIMATIONS====
  const productPageScrollAnimations = () => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    const revealItems = (
      selector,
      triggerSelector = selector,
      options = {},
    ) => {
      const start = options.start || "top 84%";
      const y = options.y || 28;
      const stagger = options.stagger || 0.08;

      gsap.utils.toArray(selector).forEach((item) => {
        const triggerItem = item.closest(triggerSelector) || item;

        gsap.set(item, {
          opacity: 0,
          y: y,
        });

        gsap.to(item, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          stagger: stagger,
          scrollTrigger: {
            trigger: triggerItem,
            start: start,
            once: true,
          },
        });
      });
    };

    gsap.utils.toArray(".productTechSpecsSection").forEach((section) => {
      const header = section.querySelector(".productTechSpecsHeader");
      const items = section.querySelectorAll(".productTechSpecsItem");

      if (header) {
        gsap.set(header, { opacity: 0, y: 22 });
        gsap.to(header, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 84%",
            once: true,
          },
        });
      }

      if (items.length) {
        gsap.set(items, { opacity: 0, y: 24, scale: 0.98 });
        gsap.to(items, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.7,
          ease: "power3.out",
          stagger: 0.05,
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            once: true,
          },
        });
      }
    });

    gsap.utils.toArray(".productPpaMlpSection").forEach((section) => {
      const headingTargets = section.querySelectorAll(
        ".productPpaMlpPreheading, .productPpaMlpTitle",
      );
      const featureItems = section.querySelectorAll(".productPpaMlpFeature");
      const mediaBox = section.querySelector(".productPpaMlpVideoBox");

      if (headingTargets.length) {
        gsap.set(headingTargets, { opacity: 0, y: 24 });
        gsap.to(headingTargets, {
          opacity: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          stagger: 0.1,
          scrollTrigger: {
            trigger: section,
            start: "top 84%",
            once: true,
          },
        });
      }

      if (featureItems.length) {
        gsap.set(featureItems, { opacity: 0, y: 22 });
        gsap.to(featureItems, {
          opacity: 1,
          y: 0,
          duration: 0.75,
          ease: "power3.out",
          stagger: 0.08,
          scrollTrigger: {
            trigger: section,
            start: "top 78%",
            once: true,
          },
        });
      }

      if (mediaBox) {
        gsap.set(mediaBox, { opacity: 0, x: 26, scale: 0.98 });
        gsap.to(mediaBox, {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 0.9,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            once: true,
          },
        });

        const mediaItem = mediaBox.querySelector(
          ".productPpaMlpVideo, .productPpaMlpFallbackImage",
        );

        if (mediaItem) {
          gsap.fromTo(
            mediaItem,
            {
              yPercent: -6,
              scale: 1.06,
            },
            {
              yPercent: 6,
              scale: 1,
              ease: "none",
              scrollTrigger: {
                trigger: mediaBox,
                start: "top bottom",
                end: "bottom top",
                scrub: 1.1,
              },
            },
          );
        }
      }
    });
  };

  // ===CUSTOM MOBILE MENU====
  const mobileMenu = () => {
    const resetMobilePanels = () => {
      $(".aplMobileMenuPanel").removeClass("is-active");
      $('.aplMobileMenuPanel[data-mobile-menu-panel="root"]').addClass("is-active");
    };

    $(document).on("click", ".mobileMenuOpener", function () {
      $(".mobile-header").addClass("isOpen");
      $("body, html").addClass("hideScroll isMobileMenuOpen");
      resetMobilePanels();
    });
    $(document).on("click", ".closeMenu", function () {
      $(".mobile-header").removeClass("isOpen");
      $("body, html").removeClass("hideScroll isMobileMenuOpen");
      resetMobilePanels();
    });
    $(document).on("click", "[data-mobile-menu-open]", function () {
      const targetPanel = $(this).attr("data-mobile-menu-open");
      $(".aplMobileMenuPanel").removeClass("is-active");
      $(`.aplMobileMenuPanel[data-mobile-menu-panel="${targetPanel}"]`).addClass(
        "is-active"
      );
    });
    $(document).on("click", "[data-mobile-menu-back]", function () {
      resetMobilePanels();
    });
  };

  // ===FOOTER / MOBILE LOCALIZATION CUSTOM DROPDOWN====
  const footerMobileCurrencyDropdown = () => {
    const dropdowns = document.querySelectorAll("[data-mobile-currency-dropdown]");

    if (!dropdowns.length) {
      return;
    }

    const closeAll = () => {
      dropdowns.forEach((dropdown) => {
        dropdown.classList.remove("is-open");
        const toggle = dropdown.querySelector("[data-mobile-currency-toggle]");
        if (toggle) {
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    };

    dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector("[data-mobile-currency-toggle]");
      const options = dropdown.querySelectorAll("[data-mobile-currency-option]");
      const select = dropdown
        .closest(".selectors-form__currency--custom")
        ?.querySelector("select[data-disclosure-list]");

      if (!toggle || !select) {
        return;
      }

      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const willOpen = !dropdown.classList.contains("is-open");
        closeAll();
        dropdown.classList.toggle("is-open", willOpen);
        toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
      });

      options.forEach((option) => {
        option.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          const value = option.getAttribute("data-value");
          if (!value) {
            return;
          }

          select.value = value;
          select.dispatchEvent(new Event("change", { bubbles: true }));

          options.forEach((item) => item.classList.remove("is-active"));
          option.classList.add("is-active");
          closeAll();
        });
      });
    });

    document.addEventListener("click", (event) => {
      if (!event.target.closest("[data-mobile-currency-dropdown]")) {
        closeAll();
      }
    });
  };

  // ===BUNDLE STRIPS====
  const toggleBundleCarousel = (
    section,
    carousel,
    options = {},
  ) => {
    const isMobile = window.matchMedia("(max-width: 798px)").matches;
    const enableDesktop =
      String(section.data("desktop-carousel")) === "true";
    const enableMobile =
      String(section.data("mobile-carousel")) === "true";
    const shouldEnable = isMobile ? enableMobile : enableDesktop;
    const isEnabled = carousel.hasClass("flickity-enabled");
    const dotsWrap = options.dotsWrap || $();
    const activeClass = options.activeClass || "is-carousel-active";
    const mobileClass = options.mobileClass || "is-mobile-carousel";
    const desktopClass = options.desktopClass || "is-desktop-carousel";

    section.removeClass(`${mobileClass} ${desktopClass}`);

    if (!shouldEnable) {
      if (isEnabled) {
        carousel.flickity("destroy");
      }
      dotsWrap.empty();
      section.removeClass(activeClass);
      return;
    }

    if (!isEnabled && typeof $.fn.flickity === "function") {
      carousel.flickity({
        wrapAround: false,
        prevNextButtons: false,
        pageDots: isMobile,
        adaptiveHeight: false,
        contain: true,
        cellAlign: "left",
        groupCells: false,
        draggable: true,
        imagesLoaded: true,
      });
    } else if (isEnabled) {
      carousel.flickity("resize");
    }

    section.addClass(activeClass);
    section.addClass(isMobile ? mobileClass : desktopClass);

    if (isMobile) {
      const pageDots = carousel.find(".flickity-page-dots");
      if (pageDots.length && dotsWrap.length) {
        dotsWrap.empty().append(pageDots);
      }
    } else {
      dotsWrap.empty();
    }
  };

  const bundleStrips = () => {
    const initCollectionStrips = () => {
      $("[data-collection-bundle-strip]").each(function () {
        const currentSection = $(this);
        const currentCarousel = currentSection.find(
          "[data-collection-bundle-carousel]",
        );
        const currentDotsWrap = currentSection.find(
          "[data-collection-bundle-dots]",
        );

        if (!currentCarousel.length) {
          return;
        }

        toggleBundleCarousel(currentSection, currentCarousel, {
          dotsWrap: currentDotsWrap,
        });
      });
    };

    const initProductStrips = () => {
      $("[data-product-bundle-strip]").each(function () {
        const currentSection = $(this);
        const currentCarousel = currentSection.find(
          "[data-product-bundle-carousel]",
        );
        const currentDotsWrap = currentSection.find("[data-product-bundle-dots]");

        if (!currentCarousel.length) {
          return;
        }

        toggleBundleCarousel(currentSection, currentCarousel, {
          dotsWrap: currentDotsWrap,
        });
      });
    };

    initCollectionStrips();
    initProductStrips();

    $(document).on("click", "[data-collection-bundle-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-collection-bundle-strip]")
        .find("[data-collection-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-collection-bundle-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-collection-bundle-strip]")
        .find("[data-collection-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("next");
      }
    });

    $(document).on("click", "[data-product-bundle-prev]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-bundle-strip]")
        .find("[data-product-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("previous");
      }
    });

    $(document).on("click", "[data-product-bundle-next]", function () {
      const currentCarousel = $(this)
        .closest("[data-product-bundle-strip]")
        .find("[data-product-bundle-carousel]");

      if (currentCarousel.hasClass("flickity-enabled")) {
        currentCarousel.flickity("next");
      }
    });

    let bundleResizeTimer = null;
    $(window).on("resize", function () {
      window.clearTimeout(bundleResizeTimer);
      bundleResizeTimer = window.setTimeout(() => {
        initCollectionStrips();
        initProductStrips();
      }, 140);
    });
  };

  // ===ZEPTO PERSONALIZER THEME==== 
  const zeptoPersonalizerTheme = () => {
    const canRefreshZeptoDrawer = () => {
      const hasManualCustomPaddle = document.querySelector(
        '[data-product-form][data-has-custom-paddle-image="true"]',
      );
      const hasZeptoPersonalizer = document.querySelector(".product-personalizer");

      return Boolean(hasZeptoPersonalizer && !hasManualCustomPaddle);
    };

    const refreshZeptoDrawer = () => {
      if (!canRefreshZeptoDrawer()) {
        return;
      }

      const now = Date.now();
      if (
        typeof window.__aplZeptoDrawerLastOpenAt === "number" &&
        now - window.__aplZeptoDrawerLastOpenAt < 700
      ) {
        return;
      }

      window.__aplZeptoDrawerLastOpenAt = now;

      console.info("[APL] Success: Product added to cart.");

      window.setTimeout(() => {
        if (typeof Shopify !== "undefined" && Shopify.theme?.jsAjaxCart) {
          Shopify.theme.jsAjaxCart.updateView();
          Shopify.theme.jsAjaxCart.showDrawer();
        }

        if (
          window.APLThemeHelpers &&
          typeof window.APLThemeHelpers.syncFreeGiftCart === "function"
        ) {
          window.APLThemeHelpers.syncFreeGiftCart();
        }
      }, 120);
    };

    const setupZeptoCartHooks = () => {
      if (window.__aplZeptoCartHooksReady === true) {
        return;
      }

      window.__aplZeptoCartHooksReady = true;

      const oldFetch = window.fetch;
      if (typeof oldFetch === "function") {
        window.fetch = function (...args) {
          const resource = args[0];
          const requestUrl =
            typeof resource === "string" ? resource : resource?.url || "";

          return oldFetch.apply(this, args).then((response) => {
            const responseUrl = String(response?.url || requestUrl || "");

            if (responseUrl.includes("/cart/add.js")) {
              refreshZeptoDrawer();
            }

            return response;
          });
        };
      }

      const oldOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        const requestUrl = String(url || "");

        if (!this.__aplZeptoCartHookBound) {
          this.__aplZeptoCartHookBound = true;
          this.addEventListener("load", function () {
            const responseUrl = String(this.responseURL || requestUrl || "");

            if (responseUrl.includes("/cart/add.js")) {
              refreshZeptoDrawer();
            }
          });
        }

        return oldOpen.apply(this, arguments);
      };
    };

    const removeZeptoForManualCanvasProducts = () => {
      let removedAny = false;
      const manualForms = document.querySelectorAll(
        '[data-product-form][data-has-custom-paddle-image="true"], [data-product-form][data-has-manual-cover="true"]',
      );

      if (!manualForms.length) {
        return false;
      }

      manualForms.forEach((form) => {
        const productSection = form.closest(".product_section") || form.parentElement;

        if (!productSection) {
          return;
        }

        productSection.querySelectorAll(".product-personalizer").forEach((personalizer) => {
          personalizer.remove();
          removedAny = true;
        });
      });

      document
        .querySelectorAll(".pplr_crop-modal, .pplrpopup, .pplr-popup")
        .forEach((modal) => {
          modal.remove();
          removedAny = true;
        });

      if (removedAny && window.__aplZeptoRemovedForManualCanvas !== true) {
        window.__aplZeptoRemovedForManualCanvas = true;
        console.info(
          "[APL] Success: Zepto personalizer disabled for manual canvas product.",
        );
      }

      return removedAny;
    };

    const getPreviewSource = (button, localPreviewImage) => {
      const localSrc = localPreviewImage?.getAttribute("src") || "";

      if (localSrc) {
        return localSrc;
      }

      const previewImages = button.querySelectorAll(".img_url, .crop_img_url");

      for (const image of previewImages) {
        const src = image.getAttribute("src") || image.getAttribute("data-psrc") || "";
        if (src && !src.includes("blank.png")) {
          return src;
        }
      }

      return "";
    };

    const syncPreviewProperty = (button, localPreviewImage) => {
      const form = button.closest("form");
      const fileInput = button.querySelector('.fileupload[name^="properties["]');
      const dataName =
        fileInput?.getAttribute("data_name") ||
        button.querySelector(".img_url, .crop_img_url")?.getAttribute("data_name") ||
        "";

      if (!form || !dataName) {
        return;
      }

      const hiddenName = `properties[${dataName} Preview]`;
      let hiddenInput = Array.from(form.querySelectorAll('input[type="hidden"]')).find(
        (input) => input.name === hiddenName
      );

      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = hiddenName;
        form.appendChild(hiddenInput);
      }

      hiddenInput.value = getPreviewSource(button, localPreviewImage);
    };

    const syncFileNameProperty = (button, fileInput) => {
      const form = button.closest("form");
      const dataName =
        fileInput?.getAttribute("data_name") ||
        button.querySelector(".img_url, .crop_img_url")?.getAttribute("data_name") ||
        "";

      if (!form || !dataName) {
        return;
      }

      const hiddenName = `properties[${dataName} File Name]`;
      let hiddenInput = Array.from(form.querySelectorAll('input[type="hidden"]')).find(
        (input) => input.name === hiddenName
      );

      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = hiddenName;
        form.appendChild(hiddenInput);
      }

      hiddenInput.value = fileInput?.files?.[0]?.name || "";
    };

    const setupPersonalizer = (personalizer) => {
      if (!personalizer || personalizer.dataset.aplZeptoReady === "true") {
        return;
      }

      personalizer.dataset.aplZeptoReady = "true";

      const uploadButtons = personalizer.querySelectorAll(".pplrfileuploadbutton");

      uploadButtons.forEach((button) => {
        let localPreviewImage = button.querySelector(".aplZeptoUploadPreview");

        if (!localPreviewImage) {
          localPreviewImage = document.createElement("img");
          localPreviewImage.className = "aplZeptoUploadPreview";
          localPreviewImage.alt = "";
          button.appendChild(localPreviewImage);
        }

        const syncUploadState = () => {
          const previewImages = button.querySelectorAll(".img_url, .crop_img_url");
          let hasUploadedImage = Boolean(localPreviewImage.getAttribute("src"));
          let uploadedSrc = localPreviewImage.getAttribute("src") || "";

          previewImages.forEach((image) => {
            const src = image.getAttribute("src") || image.getAttribute("data-psrc") || "";
            if (src && !src.includes("blank.png")) {
              hasUploadedImage = true;
              uploadedSrc = src;
            }
          });

          if (uploadedSrc) {
            localPreviewImage.setAttribute("src", uploadedSrc);
            button.style.setProperty("--zepto-upload-preview", `url("${uploadedSrc}")`);
          }

          button.classList.toggle("has-uploaded-image", hasUploadedImage);
          syncPreviewProperty(button, localPreviewImage);
        };

        syncUploadState();

        const observer = new MutationObserver(syncUploadState);
        observer.observe(button, {
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "src", "class", "data-psrc"],
        });

        const fileInput = button.querySelector(".fileupload");
        if (fileInput) {
          syncFileNameProperty(button, fileInput);

          fileInput.addEventListener("change", (event) => {
            const file = event.target.files && event.target.files[0];
            syncFileNameProperty(button, event.target);

            if (file) {
              const reader = new FileReader();
              reader.onload = (readerEvent) => {
                const dataUrl = readerEvent.target?.result;
                if (typeof dataUrl === "string" && dataUrl.length) {
                  localPreviewImage.setAttribute("src", dataUrl);
                  button.style.setProperty("--zepto-upload-preview", `url("${dataUrl}")`);
                  button.classList.add("has-uploaded-image");
                  syncPreviewProperty(button, localPreviewImage);
                }
              };
              reader.readAsDataURL(file);
            } else {
              localPreviewImage.removeAttribute("src");
              button.style.removeProperty("--zepto-upload-preview");
              button.classList.remove("has-uploaded-image");
              syncPreviewProperty(button, localPreviewImage);
            }

            window.setTimeout(syncUploadState, 250);
            window.setTimeout(syncUploadState, 900);
          });
        }
      });

      personalizer
        .querySelectorAll('.pplr_text[name^="properties["]:not(:disabled)')
        .forEach((field) => field.classList.add("aplZeptoTextField"));
    };

    const initPersonalizers = () => {
      if (removeZeptoForManualCanvasProducts()) {
        return false;
      }

      const personalizers = document.querySelectorAll(".product-personalizer");
      if (!personalizers.length) {
        return false;
      }

      personalizers.forEach(setupPersonalizer);
      return true;
    };

    initPersonalizers();
    setupZeptoCartHooks();

    let attempts = 0;
    const personalizerInterval = window.setInterval(() => {
      attempts += 1;
      const didInit = initPersonalizers();

      if (!didInit || attempts >= 20) {
        window.clearInterval(personalizerInterval);
      }
    }, 500);

  };


  // ========= Calling Initialization Functions on Load =========
  initGsapAndLenis();
  quickATC();
  collectionTabs();
  customCollectionSort();
  testimonialShowcase();
  movementGallery();
  customPaddleSteps();
  bulkProductsGrid();
  productGalleryCustomUI();
  customPaddleCanvas();
  productTopNoticeCarousel();
  productPageCustomUI();
  paddleTypeInfoPopup();
  bulkEnquiriesStickyBar();
  bulkMockupModal();
  syncFreeGiftCart();
  autoplaySectionVideos();
  homePageScrollAnimations();
  productPageScrollAnimations();
  mobileMenu();
  footerMobileCurrencyDropdown();
  bundleStrips();
  zeptoPersonalizerTheme();
  ScrollTrigger.refresh();
});
